/*
 * reviews-widget.js — Widget de reseñas del sistema propio.
 *
 * LECTURA: solo la lista es async y llama a la API de lectura v1 del backend. El
 * resumen (estrellas + aggregateRating) es server-side (reviews-stars.liquid /
 * JSON-LD) y NO se toca aquí: este archivo nunca llama a /summary.
 *
 *   GET {base}/v1/products/{encodeURIComponent(gid)}/reviews?page&per_page&sort&filter
 *     -> { data:[...], pagination:{ page, per_page, total, total_pages } }
 *
 * ESCRITURA (envío ABIERTO, sin token, sin compra verificada — ver bindForm y
 * los métodos que arrancan en fetchFormConfig):
 *   GET  {base}/v1/storefront/form-config          -> { enabled, ...límites/copy }
 *   POST {base}/v1/storefront/challenge             -> canjea 1 turnstile_token x 1 grant
 *   POST {base}/v1/media/uploads/storefront          -> presign por archivo (usa el grant)
 *   POST {base}/v1/reviews/storefront                -> envío final, siempre 202 'pending'
 * El token de Turnstile es de un solo uso: solo se manda directo cuando la reseña
 * NO lleva archivos; si lleva, se canjea una vez por un grant (~15 min) que autoriza
 * todas las subidas y el envío. Todo error es RFC 9457 (application/problem+json).
 * `submission_id` (hex de 128 bits) es obligatoria y se conserva entre reintentos:
 * es lo que evita que una respuesta perdida termine creando dos reseñas.
 *
 * Config: window.theme.settings.reviewsApiBaseUrl (base URL) + data-attrs del contenedor.
 * Lazy con IntersectionObserver. Sin jQuery. Convive con Yotpo (nodo propio, sin tocarlo).
 *
 * Swap de color (color-swatch-ajax.js): el contenedor de esta sección vive FUERA del
 * bloque swapeado, así que no se destruye ni duplica. Escuchamos 'hs:product-swapped'
 * para actualizar el GID y re-pedir solo la lista (reset a page 1).
 */
(function () {
  'use strict';

  var SETTINGS = (window.theme && window.theme.settings) || {};
  var BASE_URL = String(SETTINGS.reviewsApiBaseUrl || '').replace(/\/+$/, '');

  var SORTS = ['newest', 'oldest', 'highest', 'lowest', 'most_helpful'];

  var SVGNS = 'http://www.w3.org/2000/svg';
  // Mismo path que snippets/reviews-star-icon.liquid, para que la lista y el
  // resumen server-side usen exactamente la misma estrella.
  var STAR_PATH = 'M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z';
  // Paths de Tabler Icons (thumb-up / thumb-down), trazo.
  var THUMB_PATH = {
    up: 'M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3',
    down: 'M7 13v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 0 0 4 0v-5h3a2 2 0 0 0 2 -2l-1 -5a2 3 0 0 0 -2 -2h-7a3 3 0 0 0 -3 3'
  };

  /** Una estrella SVG (rellena en dorado o vacía en gris). */
  function svgStar(filled) {
    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'currentColor');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    if (!filled) svg.setAttribute('class', 'native-reviews__item-star--empty');
    var p = document.createElementNS(SVGNS, 'path');
    p.setAttribute('d', STAR_PATH);
    svg.appendChild(p);
    return svg;
  }

  /** Contenedor con 5 estrellas según la calificación (1–5, enteros). */
  function starsEls(rating) {
    var r = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    var wrap = el('span', 'native-reviews__item-stars');
    for (var i = 1; i <= 5; i++) wrap.appendChild(svgStar(i <= r));
    return wrap;
  }

  /**
   * Triángulo de reproducción para el póster de un video. Va sobre la miniatura
   * en la lista y sobre la del modal: sin él, un póster es indistinguible de
   * una foto y nadie sabe que hay algo que reproducir.
   */
  function playIcon() {
    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'currentColor');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var p = document.createElementNS(SVGNS, 'path');
    p.setAttribute('d', 'M8 5.14v13.72a1 1 0 0 0 1.54.84l10.3-6.86a1 1 0 0 0 0-1.68L9.54 4.3A1 1 0 0 0 8 5.14z');
    svg.appendChild(p);
    return svg;
  }

  /** Icono de pulgar (arriba/abajo) para la fila "¿Fue útil esta reseña?". */
  function thumb(dir) {
    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.6');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var p = document.createElementNS(SVGNS, 'path');
    p.setAttribute('d', THUMB_PATH[dir]);
    svg.appendChild(p);
    return svg;
  }

  function fmtDate(iso, locale) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    try {
      return new Intl.DateTimeFormat(locale || 'es-MX', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
      }).format(d);
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  /** Icono chevron (‹ / ›) para los controles de paginación. */
  function chevron(dir) {
    var SVGNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.75');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS(SVGNS, 'path');
    path.setAttribute('d', dir === 'prev' ? 'M15 18l-6 -6l6 -6' : 'M9 6l6 6l-6 6');
    svg.appendChild(path);
    return svg;
  }

  /**
   * Lista de páginas a mostrar: siempre la primera, la última y una ventana
   * alrededor de la actual; los huecos de más de una página se colapsan en '…'
   * y el hueco de exactamente una se rellena con su número.
   *   paginationRange(4, 9)  -> [1, 2, 3, 4, 5, '…', 9]
   *   paginationRange(5, 20) -> [1, '…', 4, 5, 6, '…', 20]
   */
  function paginationRange(current, total) {
    var delta = 1;
    var range = [];
    for (var i = 1; i <= total; i++) {
      if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
        range.push(i);
      }
    }
    var out = [];
    var prev;
    range.forEach(function (page) {
      if (prev) {
        if (page - prev === 2) out.push(prev + 1);
        else if (page - prev > 2) out.push('…');
      }
      out.push(page);
      prev = page;
    });
    return out;
  }

  /**
   * Hex criptográficamente aleatorio. 16 bytes = 32 chars = 128 bits, el mínimo
   * que acepta `submission_id`. Nada de Math.random(): con poca entropía dos
   * visitantes colisionan y uno recibe el 409 de la reseña de la otra.
   */
  function randomHex(bytes) {
    var buf = new Uint8Array(bytes);
    window.crypto.getRandomValues(buf);
    return Array.prototype.map.call(buf, function (b) {
      return ('0' + b.toString(16)).slice(-2);
    }).join('');
  }

  function hasCrypto() {
    return !!(window.crypto && typeof window.crypto.getRandomValues === 'function');
  }

  /**
   * "¿Ya voté esta reseña?" en localStorage.
   *
   * No existe forma de preguntárselo al backend al cargar la página, y no es un
   * olvido suyo: en la lista no cabe porque la respuesta variaría por visitante y
   * mataría el `Cache-Control: public` que la hace cacheable en el borde, y en una
   * ruta aparte sería un oráculo de privacidad ("¿votó esta IP la reseña X?").
   *
   * Así que esto es DECORACIÓN y nada más: sirve para pintar el pulgar marcado al
   * volver, y se reconcilia con el `your_vote` de cada respuesta. El dedupe lo
   * hace el servidor — este valor JAMÁS bloquea un clic.
   *
   * Una clave por reseña y no un único objeto con todas, porque dos pestañas
   * votando reseñas distintas se pisarían al reescribir el objeto entero; con
   * claves sueltas cada escritura es independiente.
   *
   * Lectura y escritura van en try/catch: en modo privado o con el almacenamiento
   * bloqueado localStorage lanza, y no poder guardar nada tiene que ser un estado
   * válido — se vota igual, solo se pierde el marcado.
   */
  var VOTE_KEY = 'nrw:helpful:';

  function readVote(reviewId) {
    try {
      var v = window.localStorage.getItem(VOTE_KEY + reviewId);
      return v === 'up' || v === 'down' ? v : '';
    } catch (e) {
      return '';
    }
  }

  /**
   * Ventana de frescura tras votar.
   *
   * La lista se sirve con `Cache-Control: public, max-age=60,
   * stale-while-revalidate=300`, y eso es DELIBERADO del backend: es lo que la
   * hace cacheable en el borde. Pero el caché del navegador obedece la misma
   * cabecera, así que quien acaba de votar y recarga la página no vuelve a pedir
   * la lista: reutiliza su propia copia de ANTES del voto y repinta el conteo
   * viejo. Con stale-while-revalidate esa copia rancia puede durar ~6 minutos, y
   * el efecto es exactamente "voté, recargué y no se guardó" — aunque el voto sí
   * esté guardado en el servidor.
   *
   * Se marca el instante del voto y, mientras dure la ventana, la lista se pide
   * con `cache: 'no-cache'`: revalida contra el origen y trae los conteos de
   * verdad. Afecta SOLO a quien votó y solo unos minutos; para todos los demás
   * —la inmensa mayoría de las visitas— el caché sigue intacto.
   */
  var FRESH_KEY = 'nrw:helpful:fresh';
  // max-age (60s) + stale-while-revalidate (300s) = 360s. 10 min deja margen.
  var FRESH_MS = 10 * 60 * 1000;

  function markVoted() {
    try {
      window.localStorage.setItem(FRESH_KEY, String(Date.now()));
    } catch (e) {
      /* sin almacenamiento no hay ventana; ver votedRecently */
    }
  }

  function votedRecently() {
    try {
      var at = parseInt(window.localStorage.getItem(FRESH_KEY), 10);
      return !!at && Date.now() - at < FRESH_MS;
    } catch (e) {
      // Sin almacenamiento tampoco se puede recordar el voto, así que no hay nada
      // que reconciliar: se deja el caché en paz.
      return false;
    }
  }

  function saveVote(reviewId, vote) {
    try {
      // `your_vote: null` = acaba de RETIRAR el voto: se BORRA la entrada, no se
      // guarda vacía.
      if (vote === 'up' || vote === 'down') window.localStorage.setItem(VOTE_KEY + reviewId, vote);
      else window.localStorage.removeItem(VOTE_KEY + reviewId);
    } catch (e) {
      /* sin almacenamiento el widget funciona igual, solo no recuerda el voto */
    }
  }

  /**
   * Normaliza una respuesta de la API: resuelve el JSON si fue 2xx y lanza
   * ProblemError (RFC 9457) si no. `Retry-After` se lee de la cabecera porque
   * el 429 y el 503 lo mandan ahí, no en el cuerpo. Si el cuerpo no es JSON
   * (un 503 del proxy, por ejemplo) se sintetiza un problem con el status.
   */
  function readProblem(res) {
    if (res.ok) {
      if (res.status === 204) return Promise.resolve({});
      return res.json().catch(function () { return {}; });
    }
    var retryAfter = parseInt(res.headers.get('Retry-After'), 10);
    return res.json().catch(function () { return {}; }).then(function (body) {
      var problem = body || {};
      if (!problem.status) problem.status = res.status;
      throw new ProblemError(problem, isNaN(retryAfter) ? 0 : retryAfter);
    });
  }

  /**
   * Estado del script de Turnstile COMPARTIDO por todas las instancias: se
   * inyecta una sola vez aunque haya varios widgets en la página. `onFail` es
   * tan importante como `onReady`: con un bloqueador de anuncios el script no
   * dispara onerror en todos los navegadores, así que hay también un timeout.
   */
  var turnstileScript = { state: 'idle', ready: [], failed: [], timer: null };

  function loadTurnstile(onReady, onFail) {
    if (window.turnstile) { onReady(); return; }
    if (turnstileScript.state === 'failed') { onFail(); return; }
    turnstileScript.ready.push(onReady);
    turnstileScript.failed.push(onFail);
    if (turnstileScript.state === 'loading') return;
    turnstileScript.state = 'loading';

    function settle(ok) {
      if (turnstileScript.state !== 'loading') return;
      turnstileScript.state = ok ? 'ready' : 'failed';
      window.clearTimeout(turnstileScript.timer);
      var queue = ok ? turnstileScript.ready : turnstileScript.failed;
      turnstileScript.ready = [];
      turnstileScript.failed = [];
      queue.forEach(function (fn) { fn(); });
    }

    var script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.onload = function () { settle(!!window.turnstile); };
    script.onerror = function () { settle(false); };
    turnstileScript.timer = window.setTimeout(function () { settle(!!window.turnstile); }, 10000);
    document.head.appendChild(script);
  }

  function ReviewsWidget(root) {
    this.root = root;
    this.gid = root.getAttribute('data-product-gid') || '';
    this.familyGids = this.parseFamilyGids(root.getAttribute('data-family-gids'));
    this.isGroup = this.familyGids.length > 1;
    this.perPage = parseInt(root.getAttribute('data-per-page'), 10) || 10;
    var defSort = root.getAttribute('data-default-sort') || 'newest';
    this.defaultSort = SORTS.indexOf(defSort) !== -1 ? defSort : 'newest';
    this.sort = this.defaultSort;
    this.filter = '';
    this.page = 1;
    this.loaded = false;
    this.hasAnyReviews = false;
    this.locale = (document.documentElement.getAttribute('lang') || 'es-MX');

    this.controlsEl = root.querySelector('[data-nrw-controls]');
    this.sortEl = root.querySelector('[data-nrw-sort]');
    this.filtersEl = root.querySelector('[data-nrw-filters]');
    this.statusEl = root.querySelector('[data-nrw-status]');
    this.listEl = root.querySelector('[data-nrw-list]');
    this.pagerEl = root.querySelector('[data-nrw-pagination]');

    // Estado del formulario de envío abierto (contrato en
    // POST /v1/reviews/storefront y compañía — ver bindForm/submitForm).
    this.formConfig = null;
    this.formConfigState = 'idle';   // idle | loading | ready | disabled | error
    this.formConfigRetry = null;
    // Permiso de VOTOS de utilidad, independiente del formulario (ver
    // applyFormConfig). null = todavía no se sabe: form-config es asíncrono y la
    // lista puede pintarse antes.
    this.helpfulEnabled = null;
    this.pendingFiles = [];
    this.submitting = false;
    this.formSucceeded = false;
    this.formTrigger = null;
    // Producto congelado al abrir el modal: el grant y la submission_id quedan
    // atados a él (ver openForm / invalidateFormSession).
    this.formGid = this.gid;
    // Idempotencia: una clave por CONTENIDO, conservada entre reintentos.
    this.submissionId = null;
    this.submissionFingerprint = null;
    // Envío cuyo resultado se perdió: se reintenta con la MISMA clave.
    this.uncertainPayload = null;
    // Concesión de /challenge: vale para UN envío y un solo producto.
    this.grantValue = null;
    this.grantGid = null;
    this.grantExpiresAt = 0;
    this.turnstileState = 'idle';    // idle | loading | ready | failed
    this.turnstileWidgetId = null;
    this.turnstileToken = '';
    this.turnstileTokenAt = 0;
    this.holdTimer = null;
    this.destroyed = false;

    // Lightbox de fotos. `gallery` es PLANA: todas las fotos de la página
    // actual de la lista, en orden de aparición, cada una con su reseña.
    // Por eso las flechas pueden cruzar de una reseña a otra.
    this.gallery = [];
    this.lbIndex = -1;
    this.lbTrigger = null;

    this.i18n = this.readI18n();
    if (this.sortEl) this.sortEl.value = 'sort:' + this.sort;

    this.bindControls();
    this.bindSummary();
    this.bindLightbox();
    this.bindNativeStars();
    this.observe();
    this.bindSwap();
    this.fetchFormConfig();
  }

  /**
   * Lista de GIDs de la familia de color (data-family-gids, separados por coma).
   * Dedup preservando orden; tope de 50 según el contrato v1. Si viene vacío,
   * cae al GID del producto actual.
   */
  ReviewsWidget.prototype.parseFamilyGids = function (raw) {
    var gids = String(raw || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    var seen = {};
    var out = [];
    gids.forEach(function (g) {
      if (!seen[g]) { seen[g] = true; out.push(g); }
    });
    if (!out.length && this.gid) out.push(this.gid);
    return out.slice(0, 50);
  };

  ReviewsWidget.prototype.readI18n = function () {
    var node = this.root.querySelector('[data-nrw-i18n]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
  };

  ReviewsWidget.prototype.t = function (key, replacements) {
    var str = this.i18n[key] || '';
    if (replacements) {
      Object.keys(replacements).forEach(function (k) {
        str = str.replace('[' + k + ']', replacements[k]);
      });
    }
    return str;
  };

  ReviewsWidget.prototype.bindControls = function () {
    var self = this;
    if (this.sortEl) {
      this.sortEl.addEventListener('change', function () {
        // El desplegable combina orden y filtros. El value codifica el tipo:
        //   "sort:<x>"   -> cambia el orden y limpia el filtro.
        //   "filter:<x>" -> aplica el filtro y vuelve al orden por defecto.
        var raw = self.sortEl.value || '';
        var sep = raw.indexOf(':');
        var kind = sep !== -1 ? raw.slice(0, sep) : 'sort';
        var value = sep !== -1 ? raw.slice(sep + 1) : raw;
        if (kind === 'filter') {
          self.filter = value;
          self.sort = self.defaultSort;
        } else {
          self.sort = SORTS.indexOf(value) !== -1 ? value : self.defaultSort;
          self.filter = '';
        }
        self.page = 1;
        self.fetch();
      });
    }
    if (this.filtersEl) {
      this.filtersEl.addEventListener('click', function (ev) {
        var btn = ev.target.closest('[data-nrw-filter]');
        if (!btn) return;
        var value = btn.getAttribute('data-nrw-filter') || '';
        self.filter = value;
        self.page = 1;
        Array.prototype.forEach.call(
          self.filtersEl.querySelectorAll('[data-nrw-filter]'),
          function (b) { b.classList.toggle('is-active', b === btn); }
        );
        self.fetch();
      });
    }
  };

  /**
   * Conecta el resumen server-side (reviews-summary.liquid) con la lista async:
   *   - Cada fila de distribución filtra por su calificación (filter=rating:N).
   *     Vuelve a hacer clic sobre la fila activa para limpiar el filtro (toggle).
   *   - El botón "Dejar Reseña" expone la acción vía evento `hs:reviews-open-form`.
   */
  ReviewsWidget.prototype.bindSummary = function () {
    var self = this;
    var rows = this.root.querySelectorAll('[data-nrw-rating]');

    Array.prototype.forEach.call(rows, function (row) {
      row.addEventListener('click', function () {
        var value = 'rating:' + (row.getAttribute('data-nrw-rating') || '');
        var isActive = self.filter === value;
        // Toggle: si la fila ya estaba activa, se limpia el filtro.
        self.filter = isActive ? '' : value;
        self.sort = self.defaultSort;
        self.page = 1;
        Array.prototype.forEach.call(rows, function (r) {
          var on = !isActive && r === row;
          r.classList.toggle('is-active', on);
          r.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (self.sortEl) self.sortEl.value = 'sort:' + self.defaultSort;
        self.fetch();
      });
    });
    this.summaryRows = rows;

    var formBtn = this.root.querySelector('[data-nrw-open-form]');
    this.openFormBtn = formBtn;
    if (formBtn) {
      formBtn.addEventListener('click', function () {
        self.formTrigger = formBtn;
        self.openForm();
        document.dispatchEvent(new CustomEvent('hs:reviews-open-form', {
          detail: { gid: self.gid }
        }));
      });
    }

    this.bindForm();
  };

  /* ==========================================================================
   * FORMULARIO ABIERTO (sin token, sin compra verificada)
   *
   *   GET  /v1/storefront/form-config     -> ¿se pinta el CTA? + límites + copy
   *   POST /v1/storefront/challenge       -> SOLO si la reseña lleva archivos
   *   POST /v1/media/uploads/storefront   -> presign por archivo (usa el grant)
   *   POST /v1/reviews/storefront         -> envío final, siempre 202 'pending'
   *
   * Cuatro reglas que gobiernan todo lo de abajo:
   *   1. `submission_id` es obligatoria, se genera una por CONTENIDO y se
   *      conserva entre reintentos: es lo que evita que una respuesta perdida
   *      cree dos reseñas.
   *   2. `grant` y `turnstile_token` son EXCLUYENTES (mandar los dos es 422).
   *   3. Un 202 nunca significa "publicada": los descartes antispam responden
   *      exactamente igual, así que el resumen y las estrellas no se tocan.
   *   4. `turnstile_action` la publica el backend y hay que declararla al
   *      renderizar el widget, o todos los envíos se rechazan con 422.
   * ========================================================================== */

  /**
   * Cablea el modal: abrir/cerrar (overlay, X, Escape), focus trap, estrellas,
   * archivos y envío. Los listeners que cuelgan de `document` se guardan en la
   * instancia porque el editor de temas recarga la sección y, sin retirarlos,
   * quedarían handlers apuntando a nodos muertos (ver destroy).
   */
  ReviewsWidget.prototype.bindForm = function () {
    var self = this;
    var modal = this.root.querySelector('[data-nrw-form]');
    if (!modal) return;
    this.formModal = modal;
    this.dialogEl = modal.querySelector('.native-reviews-form__dialog');

    // Refs usadas por submitForm / validateForm / uploadFiles.
    this.formEl = modal.querySelector('[data-nrw-form-el]');
    this.alertEl = modal.querySelector('[data-nrw-form-alert]');
    this.ratingInput = modal.querySelector('[data-nrw-form-rating]');
    this.titleInput = modal.querySelector('#nrw-form-review-title');
    this.titleReqEl = modal.querySelector('[data-nrw-form-title-req]');
    this.bodyInput = modal.querySelector('#nrw-form-body');
    this.nameInput = modal.querySelector('#nrw-form-name');
    this.emailInput = modal.querySelector('#nrw-form-email');
    this.companyInput = modal.querySelector('[data-nrw-form-company]');
    this.photoInput = modal.querySelector('[data-nrw-form-photo]');
    this.photoFieldEl = modal.querySelector('[data-nrw-form-photo-field]');
    this.photoHintEl = modal.querySelector('[data-nrw-form-photo-hint]');
    this.photoListEl = modal.querySelector('[data-nrw-form-photo-list]');
    this.turnstileEl = modal.querySelector('[data-nrw-form-turnstile]');
    this.submitBtn = modal.querySelector('[data-nrw-form-submit]');
    this.submitLabelEl = modal.querySelector('[data-nrw-form-submit-label]');
    this.successEl = modal.querySelector('[data-nrw-form-success]');
    this.successTitleEl = modal.querySelector('[data-nrw-form-success-title]');
    this.successBodyEl = modal.querySelector('[data-nrw-form-success-body]');

    // Cierre: overlay, botón X o tecla Escape.
    Array.prototype.forEach.call(
      modal.querySelectorAll('[data-nrw-form-close]'),
      function (btn) {
        btn.addEventListener('click', function () { self.closeForm(); });
      }
    );
    this.onFormKeydown = function (ev) {
      if (modal.hasAttribute('hidden')) return;
      if (ev.key === 'Escape') { self.closeForm(); return; }
      if (ev.key === 'Tab') self.trapFocus(ev);
    };
    document.addEventListener('keydown', this.onFormKeydown);

    // Selección de estrellas (grupo tipo radio).
    var stars = modal.querySelectorAll('[data-nrw-star]');
    var ratingInput = this.ratingInput;
    function paint(value) {
      Array.prototype.forEach.call(stars, function (s) {
        var v = parseInt(s.getAttribute('data-nrw-star'), 10);
        var on = v <= value;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-checked', v === value ? 'true' : 'false');
      });
    }
    this.paintStars = paint;
    Array.prototype.forEach.call(stars, function (star) {
      star.addEventListener('click', function () {
        var value = parseInt(star.getAttribute('data-nrw-star'), 10) || 0;
        if (ratingInput) ratingInput.value = String(value);
        paint(value);
        self.clearFieldError('rating');
      });
      // Vista previa al pasar el cursor.
      star.addEventListener('mouseenter', function () {
        paint(parseInt(star.getAttribute('data-nrw-star'), 10) || 0);
      });
    });
    var starWrap = modal.querySelector('[data-nrw-form-stars]');
    if (starWrap) {
      starWrap.addEventListener('mouseleave', function () {
        paint(parseInt((ratingInput && ratingInput.value) || 0, 10));
      });
    }

    // Selección de archivos: valida contra los límites de form-config y
    // arma la lista con progreso/quitar. El input real se limpia después de
    // cada selección para poder re-elegir el mismo archivo si se quita.
    if (this.photoInput) {
      this.photoInput.addEventListener('change', function () {
        var files = self.photoInput.files ? Array.prototype.slice.call(self.photoInput.files) : [];
        self.photoInput.value = '';
        self.addFiles(files);
      });
    }

    if (this.formEl) {
      this.formEl.addEventListener('submit', function (ev) {
        ev.preventDefault();
        self.submitForm();
      });
    }
  };

  ReviewsWidget.prototype.openForm = function () {
    // El CTA solo se revela con enabled === true, pero el guard evita abrir un
    // formulario que no podría enviar nada si algo lo dispara por fuera.
    if (!this.formModal || !this.formConfig || !this.formConfig.enabled) return;
    if (this.formSucceeded) this.resetForm();
    // El producto se CONGELA por intento: el grant y la submission_id quedan
    // atados a este GID. Si el swatch cambia de producto, bindSwap invalida la
    // sesión en vez de reutilizarla (ver invalidateFormSession).
    this.formGid = this.gid;
    this.formModal.removeAttribute('hidden');
    this.lockScroll();
    this.ensureTurnstile();
    if (this.dialogEl) {
      this.dialogEl.scrollTop = 0;
      // Foco al diálogo (tabindex="-1") para que el lector de pantalla anuncie
      // el título del modal antes que el primer control.
      this.dialogEl.focus();
    }
  };

  ReviewsWidget.prototype.closeForm = function () {
    if (!this.formModal || this.formModal.hasAttribute('hidden')) return;
    this.formModal.setAttribute('hidden', '');
    this.unlockScroll();
    if (this.formTrigger && typeof this.formTrigger.focus === 'function') {
      this.formTrigger.focus();
    }
  };

  /**
   * Scroll-lock con una clase en <html>, NO con style.overflow inline: el tema
   * bloquea el scroll por clase (js-drawer-open) y pisarle el estilo inline
   * dejaría la página trabada al cerrar el otro panel. Dos locks por clase
   * conviven sin pelearse.
   */
  ReviewsWidget.prototype.lockScroll = function () {
    document.documentElement.classList.add('nrw-scroll-lock');
  };

  /**
   * El lock lo comparten DOS modales (formulario y lightbox): soltarlo al
   * cerrar uno dejaría la página con scroll detrás del otro. Solo se suelta
   * cuando ninguno sigue abierto. `force` es para destroy(), donde la sección
   * entera desaparece y el lock tiene que irse pase lo que pase.
   */
  ReviewsWidget.prototype.unlockScroll = function (force) {
    if (!force && this.root.querySelector('[data-nrw-form]:not([hidden]), [data-nrw-lightbox]:not([hidden])')) return;
    document.documentElement.classList.remove('nrw-scroll-lock');
  };

  /**
   * Controles enfocables VISIBLES del diálogo. Filtrar por visibilidad importa:
   * el formulario y el bloque de éxito se alternan con [hidden], el campo de
   * archivos puede estar apagado y el honeypot vive fuera de pantalla; sin el
   * filtro, Tab se pierde en nodos invisibles.
   */
  ReviewsWidget.prototype.focusables = function (container) {
    var scope = container || this.dialogEl;
    if (!scope) return [];
    var nodes = scope.querySelectorAll(
      'button:not([disabled]):not([tabindex="-1"]), [href]:not([tabindex="-1"]), ' +
      'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]), ' +
      'select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), ' +
      'iframe, [tabindex]:not([tabindex="-1"])'
    );
    return Array.prototype.filter.call(nodes, function (n) {
      return !!(n.offsetWidth || n.offsetHeight || n.getClientRects().length);
    });
  };

  /** Ciclo de Tab dentro del diálogo mientras el modal está abierto. */
  ReviewsWidget.prototype.trapFocus = function (ev, container) {
    var focusable = this.focusables(container);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    // Justo al abrir el foco está en el propio diálogo (tabindex="-1"): Tab
    // entra por el primero y Shift+Tab por el último.
    if (focusable.indexOf(document.activeElement) === -1) {
      ev.preventDefault();
      (ev.shiftKey ? last : first).focus();
      return;
    }
    if (ev.shiftKey && document.activeElement === first) {
      ev.preventDefault();
      last.focus();
    } else if (!ev.shiftKey && document.activeElement === last) {
      ev.preventDefault();
      first.focus();
    }
  };

  /**
   * GET /v1/storefront/form-config: decide si el CTA "Dejar Reseña" se pinta.
   * Cacheable 5 min en el backend; CORS abierto a cualquier origen (única ruta
   * del formulario que lo es).
   *
   * Falla CERRADO en lo definitivo (4xx / apagado => CTA oculto) y RECUPERABLE
   * en lo transitorio: un fallo de red O UN 5xx reintentan con espera creciente.
   * Nunca revela un formulario que se abriría sin poder enviar.
   *
   * Un 5xx NO es "apagado": el contrato trata el 503 como transitorio, y un
   * reinicio por deploy o un hipo del borde dejarían el CTA escondido el resto
   * de la visita si se tomara por definitivo. El mismo fallo llegando como
   * error de red sí reintentaba, así que la asimetría era el bug.
   */
  ReviewsWidget.prototype.fetchFormConfig = function (attempt) {
    var self = this;
    // Interruptor del tema: con las reseñas nativas apagadas no se pide nada.
    if (SETTINGS.reviewsNativeEnabled === false) return;
    if (!BASE_URL) return;

    var tries = attempt || 0;
    this.formConfigState = 'loading';
    fetch(BASE_URL + '/v1/storefront/form-config', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      mode: 'cors',
      credentials: 'omit'
    })
      .then(function (res) {
        // 5xx: transitorio. Se lanza para caer en el reintento de abajo, igual
        // que un fallo de red. 4xx (404 = ruta inexistente, 403 = apagado):
        // definitivo, el CTA se oculta.
        if (res.status >= 500) throw new Error('form-config HTTP ' + res.status);
        return res.ok ? res.json() : { enabled: false };
      })
      .then(function (config) {
        if (self.destroyed) return;
        self.applyFormConfig(config || { enabled: false });
      })
      .catch(function (err) {
        if (self.destroyed) return;
        if (tries < 2) {
          self.formConfigRetry = window.setTimeout(function () {
            self.fetchFormConfig(tries + 1);
          }, tries === 0 ? 1500 : 5000);
          return;
        }
        self.formConfigState = 'error';
        self.formConfig = null;
        // Sin config no se sabe si votar está permitido: falla cerrado también
        // para los pulgares.
        self.applyHelpfulConfig(false);
        if (self.openFormBtn) self.openFormBtn.setAttribute('hidden', '');
        if (window.console && console.warn) console.warn('[native-reviews] form-config', err);
      });
  };

  ReviewsWidget.prototype.applyFormConfig = function (config) {
    config = config || { enabled: false };
    this.formConfig = null;

    // Escribir una reseña y votar si otra fue útil son permisos INDEPENDIENTES:
    // votar no crea nada ni deja un correo sin verificar, solo mueve el contador
    // de una reseña ya moderada. Por eso el backend manda `helpful_enabled` en
    // las DOS ramas de form-config, también con `enabled: false` — que es
    // justamente el estado del formulario abierto hoy en producción. Se lee
    // ANTES del return y en su propio campo, porque `formConfig` se queda en
    // null en esa rama a propósito.
    this.applyHelpfulConfig(config.helpful_enabled);

    // Sin crypto no hay `submission_id` con entropía suficiente, y sin ella no
    // hay idempotencia: mejor no ofrecer el FORMULARIO que duplicar reseñas. El
    // guardia vive aquí y no en fetchFormConfig porque allí se saltaba la
    // petición entera y apagaba de paso los votos, que no usan submission_id ni
    // entropía de ningún tipo.
    if (!config.enabled || !hasCrypto()) {
      this.formConfigState = 'disabled';
      if (this.openFormBtn) this.openFormBtn.setAttribute('hidden', '');
      return;
    }
    this.formConfig = config;
    this.formConfigState = 'ready';
    if (this.openFormBtn) this.openFormBtn.removeAttribute('hidden');

    // `title_required` manda sobre el schema: con false el título se puede
    // omitir, así que ni se marca con asterisco ni se valida como obligatorio
    // ni se rellena con nada.
    if (this.titleReqEl) {
      if (config.title_required) this.titleReqEl.removeAttribute('hidden');
      else this.titleReqEl.setAttribute('hidden', '');
    }
    if (this.titleInput) {
      this.titleInput.setAttribute('aria-required', config.title_required ? 'true' : 'false');
    }

    this.applyMediaConfig(config);
    this.applyFormCopy(config);
  };

  /**
   * Tipos y límites de archivo: SIEMPRE los que publica el backend, nunca
   * fijados en el locale (el copy solo trae marcadores [count]/[imageSize]).
   * Con media apagada el input se deshabilita además de ocultarse: mandar
   * `media_keys` con storefront_media_enabled en false responde 422.
   */
  ReviewsWidget.prototype.applyMediaConfig = function (config) {
    var maxFiles = parseInt(config.media_max_files, 10) || 0;
    var on = !!config.media_enabled && maxFiles > 0;
    if (this.formModal) {
      if (on) this.formModal.removeAttribute('data-nrw-media-disabled');
      else this.formModal.setAttribute('data-nrw-media-disabled', '');
    }
    if (this.photoInput) {
      this.photoInput.disabled = !on;
      this.photoInput.setAttribute('accept', config.media_video_enabled ? 'image/*,video/*' : 'image/*');
    }
    if (!on) {
      this.pendingFiles = [];
      this.renderFileList();
      return;
    }
    if (this.photoHintEl) {
      var key = config.media_video_enabled ? 'formPhotoHintVideo' : 'formPhotoHintImage';
      this.photoHintEl.textContent = this.t(key, {
        count: maxFiles,
        imageSize: config.media_max_image_mb,
        videoSize: config.media_max_video_mb
      });
    }
  };

  /**
   * Copy editable desde el panel de moderación: existe para cambiar el texto
   * sin desplegar el tema, así que gana sobre el server-rendered cuando llega
   * con contenido. `intro` viene vacío por defecto: vacío = no pintar.
   */
  ReviewsWidget.prototype.applyFormCopy = function (config) {
    var modal = this.formModal;
    if (!modal) return;
    var titleEl = modal.querySelector('[data-nrw-form-title]');
    if (titleEl && config.heading) titleEl.textContent = config.heading;
    if (this.submitLabelEl && config.submit_label) this.submitLabelEl.textContent = config.submit_label;
    var introEl = modal.querySelector('[data-nrw-form-intro]');
    if (introEl && config.intro) {
      introEl.textContent = config.intro;
      introEl.removeAttribute('hidden');
    }
    var emailLabelEl = modal.querySelector('[data-nrw-form-email-label]');
    if (emailLabelEl && config.email_label) emailLabelEl.textContent = config.email_label;
    var emailNoteEl = modal.querySelector('[data-nrw-form-email-note]');
    if (emailNoteEl && config.email_note) {
      emailNoteEl.textContent = config.email_note;
      emailNoteEl.removeAttribute('hidden');
    }
  };

  /* --------------------------------------------------------------------------
   * Turnstile
   * ------------------------------------------------------------------------ */

  /**
   * Render explícito por instancia al abrir el modal. `action` es obligatoria:
   * el servidor contrasta la que devuelve Cloudflare contra `turnstile_action`
   * y, si el tema declara otra o ninguna, rechaza TODOS los envíos con 422.
   * La site key también sale del backend (rotarla no debe ser un deploy).
   */
  ReviewsWidget.prototype.ensureTurnstile = function () {
    var self = this;
    var config = this.formConfig;
    if (!config || !config.captcha_required || !this.turnstileEl) return;

    if (this.turnstileWidgetId !== null) {
      // Ya renderizado: solo se renueva si el token se gastó o venció.
      if (!this.turnstileToken || this.isTokenExpired()) this.renewTurnstile();
      return;
    }
    if (this.turnstileState === 'loading') return;

    if (!config.turnstile_site_key) {
      // Error de configuración del backend (form-config trae captcha_required
      // pero turnstile_site_key vacío): el envío respondería 503.
      //
      // Mensaje DISTINTO al de "el script no cargó". Aquí no hay bloqueador que
      // desactivar ni nada que la clienta pueda hacer, y mandarla a pelear con
      // sus extensiones por un ajuste que falta en el panel le hace perder el
      // tiempo y esconde el problema de quien sí puede arreglarlo.
      this.turnstileState = 'failed';
      this.setAlert(this.t('formErrorCaptchaNotConfigured'));
      if (window.console && console.warn) {
        console.warn('[reseñas] El backend pide captcha pero form-config no trae turnstile_site_key. Configúralo en el panel.');
      }
      return;
    }

    this.turnstileState = 'loading';
    this.turnstileEl.removeAttribute('hidden');
    loadTurnstile(
      function () {
        if (self.destroyed || self.turnstileWidgetId !== null) return;
        self.turnstileState = 'ready';
        self.turnstileWidgetId = window.turnstile.render(self.turnstileEl, {
          sitekey: config.turnstile_site_key,
          action: config.turnstile_action || '',
          // El widget no se pinta salvo que Cloudflare pida interacción de verdad.
          // Es la opción que documenta Turnstile para esto ('interaction-only'), y
          // NO es lo mismo que esconderlo con display:none: ahí el reto aparecería
          // en un nodo invisible y el envío se quedaría esperando un token que
          // nadie puede resolver. La inmensa mayoría de las visitas pasan sin ver
          // nada; la que tenga que resolver algo, lo ve.
          appearance: 'interaction-only',
          // Solo cuando el reto se hace visible hace falta el hueco de debajo.
          'before-interactive-callback': function () {
            if (self.turnstileEl) self.turnstileEl.classList.add('is-interactive');
          },
          callback: function (token) {
            self.turnstileToken = token;
            self.turnstileTokenAt = Date.now();
            self.clearFieldError('turnstile_token');
          },
          'expired-callback': function () {
            // El token dura 300 s. Se conserva TODO lo escrito: solo se renueva
            // la verificación, y se renueva SOLA (turnstile.reset), que es el
            // patrón que documenta Cloudflare. Sin el reset, el widget se queda
            // vencido: la primera pulsación de "Enviar" solo servía para pedir
            // token y avisar, y hacía falta una segunda para enviar de verdad.
            // Tampoco se pinta alerta: no hay nada que la persona deba hacer.
            self.renewTurnstile();
          },
          'timeout-callback': function () { self.turnstileToken = ''; },
          'error-callback': function () { self.turnstileToken = ''; }
        });
      },
      function () {
        // Script bloqueado o inalcanzable: sin captcha no hay envío posible.
        self.turnstileState = 'failed';
        self.setAlert(self.t('formErrorCaptchaUnavailable'));
      }
    );
  };

  /** El token es de un solo uso y dura 300 s; se descarta con margen. */
  ReviewsWidget.prototype.isTokenExpired = function () {
    if (!this.turnstileTokenAt) return true;
    return (Date.now() - this.turnstileTokenAt) > 290000;
  };

  /** Pide un token nuevo sin tocar nada de lo que la persona escribió. */
  ReviewsWidget.prototype.renewTurnstile = function () {
    this.turnstileToken = '';
    this.turnstileTokenAt = 0;
    if (window.turnstile && this.turnstileWidgetId !== null) {
      try { window.turnstile.reset(this.turnstileWidgetId); } catch (e) { /* noop */ }
    }
  };

  /* --------------------------------------------------------------------------
   * Archivos
   * ------------------------------------------------------------------------ */

  /** Valida y agrega archivos a this.pendingFiles; repinta la lista. */
  ReviewsWidget.prototype.addFiles = function (files) {
    var config = this.formConfig;
    if (!config || !config.media_enabled) return;
    var maxFiles = parseInt(config.media_max_files, 10) || 0;
    var self = this;
    files.forEach(function (file) {
      if (self.pendingFiles.length >= maxFiles) {
        self.setFieldError('media_keys', self.t('formFileLimitReached', { count: maxFiles }));
        return;
      }
      var isVideo = file.type.indexOf('video/') === 0;
      var isImage = file.type.indexOf('image/') === 0;
      if ((isVideo && !config.media_video_enabled) || (!isVideo && !isImage)) {
        self.setFieldError('media_keys', self.t('formFileTypeInvalid', { name: file.name }));
        return;
      }
      // El backend revalida tamaño y tipo reales contra el bucket al enviar
      // (HEAD firmado): validar aquí evita gastar cupo del grant para nada.
      var maxMb = isVideo ? config.media_max_video_mb : config.media_max_image_mb;
      if (file.size > maxMb * 1024 * 1024) {
        self.setFieldError('media_keys', self.t('formFileTooLarge', { name: file.name, size: maxMb }));
        return;
      }
      self.pendingFiles.push({ file: file, status: 'pending', progress: 0, mediaKey: null });
    });
    this.renderFileList();
  };

  ReviewsWidget.prototype.removeFile = function (index) {
    if (this.submitting) return;
    this.pendingFiles.splice(index, 1);
    this.renderFileList();
  };

  /**
   * Olvida las claves ya subidas. Se usa cuando la concesión muere (401, 409 o
   * cambio de producto): un `media_key` solo vale para el grant y el producto
   * que lo pidieron, así que NO se transfiere entre sesiones. Se vuelve a
   * subir, avisando.
   */
  ReviewsWidget.prototype.resetUploads = function () {
    this.pendingFiles.forEach(function (entry) {
      entry.status = 'pending';
      entry.progress = 0;
      entry.mediaKey = null;
    });
    this.renderFileList();
  };

  ReviewsWidget.prototype.renderFileList = function () {
    if (!this.photoListEl) return;
    this.photoListEl.innerHTML = '';
    var self = this;
    this.pendingFiles.forEach(function (entry, index) {
      var li = el('li', 'native-reviews-form__file-item');
      if (entry.status === 'error') li.classList.add('is-error');
      var bar = el('span', 'native-reviews-form__file-progress');
      bar.style.width = entry.progress + '%';
      li.appendChild(bar);
      li.appendChild(el('span', 'native-reviews-form__file-name', entry.file.name));
      if (entry.status === 'uploading') {
        li.appendChild(el('span', 'native-reviews-form__file-status', self.t('formUploading')));
      } else {
        var removeBtn = el('button', 'native-reviews-form__file-remove', self.t('formRemoveFile'));
        removeBtn.type = 'button';
        // Quitar un archivo a mitad del envío dejaría claves huérfanas.
        removeBtn.disabled = !!self.submitting;
        removeBtn.addEventListener('click', function () { self.removeFile(index); });
        li.appendChild(removeBtn);
      }
      self.photoListEl.appendChild(li);
    });
  };

  /* --------------------------------------------------------------------------
   * Mensajes
   * ------------------------------------------------------------------------ */

  /**
   * Alerta general del formulario. El mensaje se inserta SIEMPRE como texto,
   * nunca como HTML: `detail` y `errors[].message` vienen del backend.
   * `onRetry` pinta un botón para reintentar sin perder lo escrito (503, red).
   */
  ReviewsWidget.prototype.setAlert = function (message, onRetry) {
    if (!this.alertEl) return;
    this.alertEl.textContent = '';
    if (!message) { this.alertEl.setAttribute('hidden', ''); return; }
    this.alertEl.appendChild(document.createTextNode(message));
    if (onRetry) {
      var btn = el('button', 'native-reviews-form__alert-retry', this.t('formRetry'));
      btn.type = 'button';
      btn.addEventListener('click', onRetry);
      this.alertEl.appendChild(btn);
    }
    this.alertEl.removeAttribute('hidden');
  };

  ReviewsWidget.prototype.setFieldError = function (field, message) {
    var node = this.formModal && this.formModal.querySelector('[data-nrw-form-error="' + field + '"]');
    if (!node) { this.setAlert(message); return; }
    node.textContent = message;
    node.removeAttribute('hidden');
    var wrap = node.closest('.native-reviews-form__field, .native-reviews-form__rating-field');
    if (wrap) wrap.setAttribute('data-nrw-invalid', '');
  };

  ReviewsWidget.prototype.clearFieldError = function (field) {
    var node = this.formModal && this.formModal.querySelector('[data-nrw-form-error="' + field + '"]');
    if (!node) return;
    node.setAttribute('hidden', '');
    node.textContent = '';
    var wrap = node.closest('.native-reviews-form__field, .native-reviews-form__rating-field');
    if (wrap) wrap.removeAttribute('data-nrw-invalid');
  };

  ReviewsWidget.prototype.clearAllFieldErrors = function () {
    if (!this.formModal) return;
    var self = this;
    Array.prototype.forEach.call(
      this.formModal.querySelectorAll('[data-nrw-form-error]'),
      function (node) { self.clearFieldError(node.getAttribute('data-nrw-form-error')); }
    );
    this.setAlert('');
  };

  /** Lleva el foco al primer campo marcado como inválido. */
  ReviewsWidget.prototype.focusFirstError = function () {
    if (!this.formModal) return;
    var wrap = this.formModal.querySelector('[data-nrw-invalid]');
    if (!wrap) return;
    var target = wrap.querySelector('input:not([type="hidden"]), textarea, select, button');
    if (target && typeof target.focus === 'function') target.focus();
  };

  /* --------------------------------------------------------------------------
   * Validación e idempotencia
   * ------------------------------------------------------------------------ */

  /**
   * Validación en cliente ANTES de gastar captcha o subir nada. Refleja lo que
   * valida el backend: rating 1-5, `body_min` (default 20), correo obligatorio
   * siempre (es la clave de los topes) y los máximos del schema. El título solo
   * es obligatorio si `title_required` lo dice.
   */
  ReviewsWidget.prototype.validateForm = function () {
    this.clearAllFieldErrors();
    var config = this.formConfig || {};
    var bodyMin = parseInt(config.body_min, 10) || 20;
    var values = {
      rating: parseInt((this.ratingInput && this.ratingInput.value) || 0, 10),
      title: ((this.titleInput && this.titleInput.value) || '').trim(),
      body: ((this.bodyInput && this.bodyInput.value) || '').trim(),
      display_name: ((this.nameInput && this.nameInput.value) || '').trim(),
      email: ((this.emailInput && this.emailInput.value) || '').trim()
    };
    var ok = true;

    if (!values.rating || values.rating < 1 || values.rating > 5) {
      this.setFieldError('rating', this.t('formRatingRequired'));
      ok = false;
    }
    // Con title_required en false el título se puede omitir o mandar vacío.
    if (config.title_required && !values.title) {
      this.setFieldError('title', this.t('formFieldRequired'));
      ok = false;
    } else if (values.title.length > 120) {
      this.setFieldError('title', this.t('formFieldTooLong', { count: 120 }));
      ok = false;
    }
    if (!values.body || values.body.length < bodyMin) {
      this.setFieldError('body', this.t('formBodyMinError', { count: bodyMin }));
      ok = false;
    } else if (values.body.length > 5000) {
      this.setFieldError('body', this.t('formFieldTooLong', { count: 5000 }));
      ok = false;
    }
    if (!values.display_name) {
      this.setFieldError('display_name', this.t('formFieldRequired'));
      ok = false;
    } else if (values.display_name.length > 80) {
      this.setFieldError('display_name', this.t('formFieldTooLong', { count: 80 }));
      ok = false;
    }
    if (!values.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      this.setFieldError('email', this.t('formEmailInvalid'));
      ok = false;
    }
    return { ok: ok, values: values };
  };

  /**
   * Huella del CONTENIDO del envío. Las credenciales (grant, turnstile_token)
   * quedan fuera a propósito: un reintento trae captcha nuevo por necesidad y
   * sigue siendo el mismo envío. Los archivos se identifican por nombre+tamaño,
   * no por su media_key, que solo aparece a mitad del flujo.
   */
  ReviewsWidget.prototype.contentFingerprint = function (values) {
    var files = this.pendingFiles.map(function (entry) {
      return entry.file.name + ':' + entry.file.size;
    });
    return JSON.stringify([
      this.formGid,
      values.rating,
      values.title,
      values.body,
      values.display_name,
      values.email,
      files
    ]);
  };

  /**
   * La clave del intento. Misma clave + mismo contenido => el backend reemite
   * la respuesta original sin crear una segunda reseña (salva el caso "envié,
   * se cayó la red, reintento"). Misma clave + contenido distinto => 409, así
   * que si la persona edita tras un error se estrena clave.
   */
  ReviewsWidget.prototype.ensureSubmissionId = function (values) {
    var fingerprint = this.contentFingerprint(values);
    if (!this.submissionId || this.submissionFingerprint !== fingerprint) {
      this.submissionId = randomHex(16);
      this.submissionFingerprint = fingerprint;
    }
    return this.submissionId;
  };

  ReviewsWidget.prototype.clearGrant = function () {
    this.grantValue = null;
    this.grantGid = null;
    this.grantExpiresAt = 0;
  };

  /**
   * Invalida y recrea la sesión del formulario. Se llama cuando el producto
   * cambia (swatch de color): el grant está atado al GID anterior y las claves
   * de archivo no se transfieren, así que no se reutiliza nada.
   */
  ReviewsWidget.prototype.invalidateFormSession = function () {
    this.clearGrant();
    this.resetUploads();
    this.submissionId = null;
    this.submissionFingerprint = null;
    this.uncertainPayload = null;
    if (this.formModal && !this.formModal.hasAttribute('hidden')) {
      this.formGid = this.gid;
      this.renewTurnstile();
      this.setAlert(this.t('formErrorProductChanged'));
    }
  };

  /* --------------------------------------------------------------------------
   * Envío
   * ------------------------------------------------------------------------ */

  /** Sube un archivo: presign (fetch) + PUT a la URL firmada (XHR, progreso). */
  ReviewsWidget.prototype.uploadOne = function (entry, grant) {
    var self = this;
    entry.status = 'uploading';
    entry.progress = 0;
    this.renderFileList();
    return fetch(BASE_URL + '/v1/media/uploads/storefront', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      mode: 'cors',
      credentials: 'omit',
      body: JSON.stringify({
        content_type: entry.file.type,
        byte_size: entry.file.size,
        filename: entry.file.name,
        grant: grant
      })
    })
      .then(readProblem)
      .then(function (presign) {
        return new Promise(function (resolve, reject) {
          var xhr = new XMLHttpRequest();
          // URL, método y cabeceras son los que devuelve el backend: el
          // Content-Type va firmado y con otro el almacenamiento rechaza.
          xhr.open(presign.method || 'PUT', presign.upload_url, true);
          var headers = presign.headers || {};
          Object.keys(headers).forEach(function (h) { xhr.setRequestHeader(h, headers[h]); });
          xhr.upload.addEventListener('progress', function (ev) {
            if (!ev.lengthComputable) return;
            entry.progress = Math.round((ev.loaded / ev.total) * 100);
            self.renderFileList();
          });
          xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
              entry.mediaKey = presign.media_key;
              entry.status = 'done';
              entry.progress = 100;
              entry.expiresAt = Date.parse(presign.expires_at) || 0;
              resolve(presign.media_key);
            } else {
              reject(new Error('upload HTTP ' + xhr.status));
            }
          };
          xhr.onerror = function () { reject(new Error('upload network error')); };
          xhr.send(entry.file);
        });
      })
      .catch(function (err) {
        entry.status = 'error';
        self.renderFileList();
        throw err;
      });
  };

  /**
   * Sube los archivos en SERIE (no en paralelo) para no saturar un móvil. Un
   * reintento no vuelve a subir lo que ya quedó en 'done' con su media_key: el
   * contador por grant cuenta prefirmas, así que re-subir gastaría cupo. Por eso
   * un 422 de contenido no vuelve a subir nada.
   */
  ReviewsWidget.prototype.uploadFiles = function (grant) {
    var self = this;
    var mediaKeys = [];
    return this.pendingFiles.reduce(function (chain, entry) {
      return chain.then(function () {
        if (entry.status === 'done' && entry.mediaKey) {
          mediaKeys.push(entry.mediaKey);
          return;
        }
        return self.uploadOne(entry, grant).then(function (key) { mediaKeys.push(key); });
      });
    }, Promise.resolve()).then(function () { return mediaKeys; });
  };

  /**
   * Canjea el token de Turnstile por una concesión (~15 min) atada al producto.
   * Solo hace falta cuando la reseña lleva archivos. Se reutiliza mientras siga
   * viva y sea del MISMO producto; el token se gasta en el canje.
   */
  ReviewsWidget.prototype.ensureGrant = function () {
    var self = this;
    if (this.grantValue && this.grantGid === this.formGid && Date.now() < this.grantExpiresAt - 30000) {
      return Promise.resolve(this.grantValue);
    }
    this.clearGrant();
    return fetch(BASE_URL + '/v1/storefront/challenge', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      mode: 'cors',
      credentials: 'omit',
      // product_gid va sin percent-encodear: aquí viaja en el cuerpo.
      body: JSON.stringify({ turnstile_token: this.turnstileToken || '', product_gid: this.formGid })
    })
      .then(readProblem)
      .then(function (challenge) {
        self.turnstileToken = '';
        self.turnstileTokenAt = 0;
        self.grantValue = challenge.grant;
        self.grantGid = self.formGid;
        self.grantExpiresAt = Date.parse(challenge.expires_at) || (Date.now() + 900000);
        return self.grantValue;
      });
  };

  /**
   * Arma el cuerpo del POST final. El schema es estricto: cualquier campo de
   * más es 422, así que solo va lo que el contrato define, y el título se omite
   * cuando viene vacío. `grant` y `turnstile_token` son excluyentes.
   */
  ReviewsWidget.prototype.buildPayload = function (submissionId, values, credential) {
    var payload = {
      submission_id: submissionId,
      product_gid: this.formGid,
      rating: values.rating,
      body: values.body,
      display_name: values.display_name,
      email: values.email,
      company: (this.companyInput && this.companyInput.value) || ''
    };
    if (values.title) payload.title = values.title;
    if (credential.media_keys && credential.media_keys.length) {
      payload.media_keys = credential.media_keys;
    }
    if (credential.grant) payload.grant = credential.grant;
    else if (credential.turnstile_token) payload.turnstile_token = credential.turnstile_token;
    return payload;
  };

  /**
   * Orquesta el envío: valida -> (si hay archivos) canjea el token por un grant
   * y sube -> POST final. Con archivos el grant es obligatorio; sin ellos va el
   * turnstile_token directo, en un solo viaje.
   */
  ReviewsWidget.prototype.submitForm = function () {
    var self = this;
    if (this.submitting) return;           // anti doble submit
    if (this.formSucceeded) return;
    var config = this.formConfig;
    if (!config || !config.enabled) return;

    // Resultado incierto: el envío anterior PUDO haber llegado. Se reenvía el
    // mismo payload con la misma submission_id para que el backend reemita su
    // respuesta en vez de crear una segunda reseña. Nunca una clave nueva.
    if (this.uncertainPayload) {
      this.retryUncertain();
      return;
    }

    var validation = this.validateForm();
    if (!validation.ok) { this.focusFirstError(); return; }
    var values = validation.values;
    var hasFiles = this.pendingFiles.length > 0;

    if (config.captcha_required) {
      if (this.turnstileState === 'failed') {
        this.setAlert(this.t('formErrorCaptchaUnavailable'));
        return;
      }
      if (!this.turnstileToken || this.isTokenExpired()) {
        // Se conserva TODO lo escrito y la selección: solo falta verificar.
        this.renewTurnstile();
        this.setAlert(this.t('formErrorCaptchaExpired'));
        return;
      }
    }

    var submissionId = this.ensureSubmissionId(values);
    this.submitting = true;
    this.setSubmitting(true);
    this.setAlert('');

    var chain;
    if (hasFiles) {
      chain = this.ensureGrant().then(function (grant) {
        return self.uploadFiles(grant).then(function (keys) {
          return { grant: grant, media_keys: keys };
        });
      });
    } else {
      chain = Promise.resolve({ turnstile_token: this.turnstileToken || '', media_keys: [] });
    }

    chain
      .then(function (credential) {
        return self.sendReview(self.buildPayload(submissionId, values, credential));
      })
      .catch(function (err) { self.onPreflightError(err); });
  };

  /**
   * POST final. Distingue tres desenlaces:
   *   - 202          -> éxito (siempre 'pending'; también los descartes antispam).
   *   - ProblemError -> el backend respondió: el envío NO se guardó como está.
   *   - fallo de red -> INCIERTO: pudo haberse guardado. Se conserva el payload
   *                     y se reintenta con la misma clave.
   */
  ReviewsWidget.prototype.sendReview = function (payload) {
    var self = this;
    this.submitting = true;
    this.setSubmitting(true);
    return fetch(BASE_URL + '/v1/reviews/storefront', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      mode: 'cors',
      credentials: 'omit',
      body: JSON.stringify(payload)
    })
      .then(readProblem)
      .then(function () {
        self.submitting = false;
        self.setSubmitting(false);
        self.uncertainPayload = null;
        // Una concesión sirve para UN envío: reutilizarla sería 409.
        self.clearGrant();
        // Éxito confirmado: NO se vuelve a pedir captcha para recuperar algo
        // que ya se completó, solo se olvida el token gastado.
        self.turnstileToken = '';
        self.turnstileTokenAt = 0;
        self.showSuccess();
      })
      .catch(function (err) {
        self.submitting = false;
        self.setSubmitting(false);
        if (err instanceof ProblemError) {
          self.uncertainPayload = null;
          self.handleSubmitError(err);
          return;
        }
        self.uncertainPayload = payload;
        self.renewTurnstile();
        self.setAlert(self.t('formErrorUncertain'), function () { self.retryUncertain(); });
        if (window.console && console.warn) console.warn('[native-reviews] submit', err);
      });
  };

  /**
   * Reintento de un resultado incierto: MISMO payload, MISMA submission_id. Lo
   * único que se refresca es la credencial, que no cuenta como contenido.
   */
  ReviewsWidget.prototype.retryUncertain = function () {
    var self = this;
    var payload = this.uncertainPayload;
    if (!payload || this.submitting) return;
    var config = this.formConfig || {};
    if (config.captcha_required && !payload.grant) {
      if (!this.turnstileToken || this.isTokenExpired()) {
        this.renewTurnstile();
        this.setAlert(this.t('formErrorCaptchaExpired'), function () { self.retryUncertain(); });
        return;
      }
      payload.turnstile_token = this.turnstileToken;
    }
    this.sendReview(payload);
  };

  /**
   * Error ANTES de que el backend aceptara nada (challenge, subida o red al
   * salir). El envío todavía no existe, así que la submission_id se conserva
   * tal cual y se puede reintentar sin riesgo de duplicar.
   */
  ReviewsWidget.prototype.onPreflightError = function (err) {
    var self = this;
    this.submitting = false;
    this.setSubmitting(false);
    if (err instanceof ProblemError) { this.handleSubmitError(err); return; }
    this.renewTurnstile();
    this.setAlert(this.t('formErrorNetwork'), function () { self.submitForm(); });
    if (window.console && console.warn) console.warn('[native-reviews] submit', err);
  };

  ReviewsWidget.prototype.setSubmitting = function (isSubmitting) {
    if (this.submitBtn) this.submitBtn.disabled = isSubmitting;
    if (this.formEl) this.formEl.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    if (this.submitLabelEl) {
      this.submitLabelEl.textContent = isSubmitting
        ? this.t('formSending')
        : ((this.formConfig && this.formConfig.submit_label) || this.t('formSubmitDefault'));
    }
    this.renderFileList();
  };

  /**
   * 429: respeta Retry-After dejando el envío bloqueado hasta que pase.
   *
   * El tope es una hora, no cinco minutos: las ventanas del backend son por
   * hora y en producción el Retry-After llega cerca de 3300 s. Con el tope
   * viejo el botón revivía a los 300 s mientras la propia alerta seguía
   * diciendo que faltaban ~55 minutos, y el clic solo servía para gastar otra
   * petición del cupo de 60/hora y cobrar el mismo 429.
   */
  ReviewsWidget.prototype.holdSubmit = function (seconds) {
    var self = this;
    var wait = Math.min(Math.max(parseInt(seconds, 10) || 0, 0), 3600);
    if (!wait || !this.submitBtn) return;
    this.submitBtn.disabled = true;
    window.clearTimeout(this.holdTimer);
    this.holdTimer = window.setTimeout(function () {
      if (!self.destroyed && !self.submitting) self.setSubmitting(false);
    }, wait * 1000);
  };

  function problemField(problem) {
    return (problem && problem.errors && problem.errors[0] && problem.errors[0].field) || '';
  }

  /**
   * Traduce la respuesta RFC 9457 a mensajes por campo / alerta general. Todos
   * los textos se pintan como TEXTO, nunca como HTML.
   */
  ReviewsWidget.prototype.handleSubmitError = function (err) {
    var self = this;
    if (!(err instanceof ProblemError)) {
      this.setAlert(this.t('formErrorNetwork'));
      return;
    }
    var problem = err.problem || {};
    var status = problem.status || 0;
    // Cualquier respuesta del backend significa que el token ya se gastó.
    this.turnstileToken = '';
    this.turnstileTokenAt = 0;

    if (status === 403) {
      // El interruptor del backend está apagado: el CTA no debería existir.
      this.formConfig = null;
      this.formConfigState = 'disabled';
      if (this.openFormBtn) this.openFormBtn.setAttribute('hidden', '');
      if (this.submitBtn) this.submitBtn.disabled = true;
      this.setAlert(problem.detail || this.t('formErrorForbidden'));
      return;
    }
    if (status === 409) {
      // Clave reutilizada con otro contenido, o concesión ya consumida.
      // Reintentar idéntico NO lo arregla: se estrena clave (y concesión).
      this.submissionId = null;
      this.submissionFingerprint = null;
      if (problemField(problem) === 'grant') {
        this.clearGrant();
        this.resetUploads();
      }
      this.renewTurnstile();
      this.setAlert(problem.detail || this.t('formErrorConflict'));
      return;
    }
    if (status === 429) {
      this.setAlert(problem.detail || this.t('formErrorRateLimitFallback'));
      this.renewTurnstile();
      this.holdSubmit(err.retryAfter);
      return;
    }
    if (status === 503) {
      // No llegó a guardarse nada: se reintenta con la MISMA submission_id.
      this.renewTurnstile();
      this.setAlert(problem.detail || this.t('formErrorServiceUnavailable'), function () {
        self.submitForm();
      });
      return;
    }
    if (status === 401) {
      // Grant vencido (solo en /media/uploads): captcha nuevo y a subir otra vez.
      this.clearGrant();
      this.resetUploads();
      this.renewTurnstile();
      this.setAlert(this.t('formErrorMediaSessionExpired'));
      return;
    }
    if (status === 415) {
      this.renewTurnstile();
      this.setFieldError('media_keys', problem.detail || this.t('formFileTypeInvalidGeneric'));
      return;
    }
    if (problem.errors && problem.errors.length) {
      problem.errors.forEach(function (e) { self.setFieldError(e.field, e.message); });
      if (problem.detail) this.setAlert(problem.detail);
      this.renewTurnstile();
      this.focusFirstError();
      return;
    }
    // Un 422 sin `errors` pinta solo el detail general.
    this.renewTurnstile();
    this.setAlert(problem.detail || this.t('formErrorGeneric'));
  };

  /**
   * Éxito DENTRO del modal. El backend siempre responde 'pending' (incluidos
   * los descartes antispam, que devuelven el mismo 202 a propósito y no se
   * pueden ni se deben distinguir), así que el mensaje dice que se publica tras
   * revisión y NO se tocan las estrellas, el total ni el resumen.
   */
  ReviewsWidget.prototype.showSuccess = function () {
    this.formSucceeded = true;
    this.uncertainPayload = null;
    this.setAlert('');
    if (this.formEl) this.formEl.setAttribute('hidden', '');
    if (this.successEl) this.successEl.removeAttribute('hidden');
    var config = this.formConfig || {};
    if (this.successTitleEl) this.successTitleEl.textContent = this.t('formSuccessTitle');
    if (this.successBodyEl) {
      this.successBodyEl.textContent = config.success_body || this.t('formSuccessBodyFallback');
    }
    // Foco al título del éxito (tabindex="-1") para que el lector de pantalla
    // lo anuncie; el botón de cerrar queda a un Tab.
    if (this.successTitleEl && typeof this.successTitleEl.focus === 'function') {
      this.successTitleEl.focus();
    }
  };

  /**
   * Vuelve el modal a un formulario en blanco (tras cerrar un envío exitoso).
   * No se persiste nada en el navegador: ni correo ni credenciales.
   */
  ReviewsWidget.prototype.resetForm = function () {
    this.formSucceeded = false;
    this.pendingFiles = [];
    this.uncertainPayload = null;
    this.submissionId = null;
    this.submissionFingerprint = null;
    this.clearGrant();
    this.renderFileList();
    this.clearAllFieldErrors();
    if (this.ratingInput) this.ratingInput.value = '';
    if (this.paintStars) this.paintStars(0);
    if (this.titleInput) this.titleInput.value = '';
    if (this.bodyInput) this.bodyInput.value = '';
    if (this.nameInput) this.nameInput.value = '';
    if (this.emailInput) this.emailInput.value = '';
    if (this.companyInput) this.companyInput.value = '';
    if (this.successEl) this.successEl.setAttribute('hidden', '');
    if (this.formEl) this.formEl.removeAttribute('hidden');
    window.clearTimeout(this.holdTimer);
    this.setSubmitting(false);
  };

  ReviewsWidget.prototype.observe = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) {
      this.fetch();
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          io.disconnect();
          self.fetch();
        }
      });
    }, { rootMargin: '300px 0px' });
    // Se guarda para desconectarlo en destroy(): el editor de temas recarga la
    // sección y el observador quedaría vigilando un nodo que ya no existe.
    this.io = io;
    io.observe(this.root);
  };

  ReviewsWidget.prototype.bindSwap = function () {
    var self = this;
    this.onProductSwapped = function (ev) {
      var detail = ev.detail || {};
      if (!detail.gid || detail.gid === self.gid) return;
      self.gid = detail.gid;
      self.root.setAttribute('data-product-gid', detail.gid);
      // El swap re-renderiza las estrellas junto al precio desde el servidor:
      // el nodo es NUEVO y llega sin los handlers. Hay que volver a cablearlo.
      self.bindNativeStars();
      // El producto del formulario se congela por intento. Si el swatch cambia
      // de producto hay que invalidar la sesión explícitamente: el grant está
      // atado al GID anterior y las claves de archivo no se transfieren. El
      // formulario nunca usa la familia de color agregada, solo este GID.
      self.invalidateFormSession();
      // En modo grupo (familia de color) la lista fusionada es la MISMA para todos
      // los colores: solo cambia el GID de contexto, no re-pedimos la lista.
      if (self.isGroup) {
        // Las estrellas junto al precio se re-renderizan server-side en el swap
        // (desde el metafield). Re-aplicamos la reconciliación con el último total
        // conocido para no re-mostrar estrellas fantasma tras cambiar de color.
        self.reconcileNativeSummary(self.hasAnyReviews ? 1 : 0);
        return;
      }
      // Modo producto único: el producto cambió -> reset y re-fetch.
      self.page = 1;
      self.filter = '';
      self.sort = self.defaultSort;
      self.hasAnyReviews = false;
      if (self.sortEl) self.sortEl.value = 'sort:' + self.defaultSort;
      if (self.summaryRows) {
        Array.prototype.forEach.call(self.summaryRows, function (r) {
          r.classList.remove('is-active');
          r.setAttribute('aria-pressed', 'false');
        });
      }
      // Re-pedir solo la lista para el nuevo GID (el nodo no se recrea).
      self.fetch();
    };
    document.addEventListener('hs:product-swapped', this.onProductSwapped);
  };

  ReviewsWidget.prototype.buildUrl = function () {
    var q = [
      'page=' + encodeURIComponent(this.page),
      'per_page=' + encodeURIComponent(this.perPage),
      'sort=' + encodeURIComponent(this.sort)
    ];
    if (this.filter) q.push('filter=' + encodeURIComponent(this.filter));
    // Familia de color: fusiona la lista de todos los hermanos vía /product-groups.
    // gids = lista unida por coma, URL-encoded como un solo valor.
    if (this.isGroup) {
      q.unshift('gids=' + encodeURIComponent(this.familyGids.join(',')));
      return BASE_URL + '/v1/product-groups/reviews?' + q.join('&');
    }
    return BASE_URL + '/v1/products/' + encodeURIComponent(this.gid) + '/reviews?' + q.join('&');
  };

  ReviewsWidget.prototype.setStatus = function (message, state, withRetry) {
    if (!this.statusEl) return;
    this.statusEl.textContent = '';
    if (state) this.statusEl.setAttribute('data-state', state);
    else this.statusEl.removeAttribute('data-state');
    if (!message) return;
    this.statusEl.appendChild(document.createTextNode(message));
    if (withRetry) {
      var self = this;
      var btn = el('button', null, this.t('retry'));
      btn.type = 'button';
      btn.addEventListener('click', function () { self.fetch(); });
      this.statusEl.appendChild(btn);
    }
  };

  ReviewsWidget.prototype.renderSkeleton = function () {
    this.listEl.innerHTML = '';
    for (var i = 0; i < 3; i++) {
      var sk = el('li', 'native-reviews__skeleton');
      sk.appendChild(el('span'));
      sk.appendChild(el('span'));
      sk.appendChild(el('span'));
      this.listEl.appendChild(sk);
    }
  };

  ReviewsWidget.prototype.fetch = function () {
    var self = this;
    if (!BASE_URL || !this.gid) {
      this.setStatus(this.t('error'), 'error', false);
      return;
    }
    this.setStatus(this.t('loading'), 'loading', false);
    this.renderSkeleton();
    this.pagerEl.innerHTML = '';

    fetch(this.buildUrl(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      mode: 'cors',
      credentials: 'omit',
      // Recién votado: revalidar para no repintar los conteos de antes del voto
      // desde el caché del navegador (ver votedRecently).
      cache: votedRecently() ? 'no-cache' : 'default'
    })
      .then(function (res) {
        var ctype = res.headers.get('content-type') || '';
        if (!res.ok) {
          if (ctype.indexOf('application/problem+json') !== -1 || ctype.indexOf('json') !== -1) {
            return res.json().then(function (problem) {
              throw new ProblemError(problem);
            });
          }
          throw new Error('HTTP ' + res.status);
        }
        return res.json();
      })
      .then(function (payload) {
        self.loaded = true;
        self.render(payload);
      })
      .catch(function (err) {
        self.loaded = true;
        self.listEl.innerHTML = '';
        var detail = (err && err.problem && (err.problem.detail || err.problem.title)) || self.t('error');
        self.setStatus(detail, 'error', true);
        if (window.console && console.warn) console.warn('[native-reviews]', err);
      });
  };

  function ProblemError(problem, retryAfter) {
    this.name = 'ProblemError';
    this.problem = problem || {};
    // Segundos de la cabecera Retry-After (429 / 503); 0 si no vino.
    this.retryAfter = retryAfter || 0;
    this.message = this.problem.title || 'Problem';
  }
  ProblemError.prototype = Object.create(Error.prototype);

  ReviewsWidget.prototype.render = function (payload) {
    var data = (payload && payload.data) || [];
    var pagination = (payload && payload.pagination) || { page: 1, per_page: this.perPage, total: data.length, total_pages: 1 };

    // ¿El producto tiene reseñas? (solo confiable en la vista sin filtro, page 1).
    if (!this.filter && this.page === 1) {
      this.hasAnyReviews = pagination.total > 0;
      this.reconcileNativeSummary(pagination.total);
    }

    // Mostrar controles solo si el producto tiene al menos una reseña.
    if (this.controlsEl) {
      if (this.hasAnyReviews) this.controlsEl.removeAttribute('hidden');
      else this.controlsEl.setAttribute('hidden', '');
    }

    // La galería del lightbox indexa la lista que se está pintando: si la
    // lista se reemplaza (paginación, filtro, swap de color), los índices
    // viejos ya no significan nada y el modal abierto queda apuntando a otra
    // foto. Se cierra y se reconstruye.
    this.closeLightbox();
    this.gallery = [];
    this.listEl.innerHTML = '';

    if (!data.length) {
      this.setStatus(this.t('empty'), 'empty', false);
      this.pagerEl.innerHTML = '';
      return;
    }

    this.setStatus('', null, false);
    var self = this;
    data.forEach(function (review) {
      self.listEl.appendChild(self.renderItem(review));
    });
    this.renderPagination(pagination);
  };

  /**
   * Reconciliación con la fuente de verdad (la API). El resumen (estrellas + "basado
   * en N") y las estrellas junto al precio se pintan server-side desde metafields para
   * SEO / no-CLS, pero esos metafields pueden quedar DESFASADOS y anunciar reseñas que
   * la API ya no devuelve. Si la vista sin filtro en page 1 trae total 0, ocultamos:
   *   - el resumen  ([data-nrw-summary], dentro del root del widget), y
   *   - las estrellas junto al precio ([data-native-reviews-stars], FUERA del root).
   * Usamos style.display (no el atributo hidden) porque las reglas por clase
   * (display:flex / inline-flex) ganarían sobre [hidden]. Parche interino: la raíz es
   * re-sincronizar los metafields en el backend (y no emitir aggregateRating fantasma).
   *
   * El CTA queda SIEMPRE fuera de lo que se oculta: sin reseñas es justo cuando
   * más falta hace poder dejar la primera.
   *
   * ## Solo oculta; nunca revela
   *
   * El desfase va en los DOS sentidos, pero solo uno se puede arreglar desde aquí.
   * Si la API trae más reseñas que los metafields —la ventana de ~60 s entre
   * aprobar en el panel y el barrido del `outbox` que escribe los metafields, o
   * para siempre si ese sync falla— revelar el bloque enseñaría el markup
   * server-side tal cual está: promedio 0, estrellas vacías, barras a cero y
   * "basado en 0 opiniones", con la lista debajo mostrando reseñas de verdad. Y
   * de paso escondería el "sé la primera".
   *
   * Las cifras no las tiene el JS (vienen del servidor), así que no puede
   * corregirlas: lo único honesto es no tocar lo que el servidor decidió no
   * pintar y dejar que el resumen aparezca en la siguiente carga, ya con los
   * metafields al día. Ocultar sí, porque ahí las cifras sobran del todo.
   */
  ReviewsWidget.prototype.reconcileNativeSummary = function (total) {
    var hasReviews = total > 0;
    // La API manda solo para DESMENTIR al servidor, no para confirmarlo.
    if (hasReviews) return;
    // Solo las cifras: el CTA "Dejar Reseña" vive FUERA de [data-nrw-summary-stats]
    // justo porque ocultarlo con ellas impediría dejar la primera reseña de un
    // producto, que es el caso que más importa.
    var stats = this.root.querySelector('[data-nrw-summary-stats]');
    if (stats) stats.style.display = 'none';
    var emptyEl = this.root.querySelector('[data-nrw-summary-empty]');
    if (emptyEl) emptyEl.style.display = '';
    var summary = this.root.querySelector('[data-nrw-summary]');
    if (summary) summary.classList.add('is-empty');
    var stars = document.querySelectorAll('[data-native-reviews-stars]');
    Array.prototype.forEach.call(stars, function (node) {
      node.style.display = 'none';
    });
  };

  ReviewsWidget.prototype.renderItem = function (review) {
    var self = this;
    var item = el('li', 'native-reviews__item');

    // Columna izquierda: nombre + país.
    var aside = el('div', 'native-reviews__item-aside');
    var nameLine = el('div', 'native-reviews__item-nameline');
    nameLine.appendChild(el('span', 'native-reviews__item-name', review.display_name || ''));
    nameLine.appendChild(el('span', 'native-reviews__item-country', review.country || 'MX'));
    aside.appendChild(nameLine);
    item.appendChild(aside);

    // Columna derecha: estrellas + título + fecha, cuerpo, media, respuesta, utilidad.
    var main = el('div', 'native-reviews__item-main');

    var top = el('div', 'native-reviews__item-top');
    var stars = starsEls(review.rating);
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', this.t('ratingAria', { rating: review.rating }));
    top.appendChild(stars);
    if (review.title) top.appendChild(el('span', 'native-reviews__item-title', review.title));
    var date = fmtDate(review.created_at, this.locale);
    if (date) top.appendChild(el('span', 'native-reviews__item-date', date));
    main.appendChild(top);

    if (review.body) main.appendChild(el('p', 'native-reviews__item-body', review.body));

    var media = review.media || [];
    if (media.length) {
      var mediaWrap = el('div', 'native-reviews__media');
      // Fotos Y videos entran a la galería. El video de la lista NO se reproduce
      // ahí: se pinta como póster con un triángulo de play y abre el modal, que es
      // donde hay sitio para verlo. Un <video controls> en una miniatura de 100px
      // es injugable, y además su clic pelearía con el que abre el lightbox.
      media.forEach(function (m) {
        if (!m || !m.url) return;
        var isVideo = m.type === 'video';
        // Un video sin thumbnail_url no tiene póster que enseñar; se cae a una
        // baldosa oscura con el play, en vez de a una imagen rota.
        var poster = m.thumbnail_url || (isVideo ? '' : m.url);

        var openBtn = el('button', 'native-reviews__media-btn');
        openBtn.type = 'button';
        if (isVideo) openBtn.className += ' native-reviews__media-btn--video';
        openBtn.setAttribute('data-nrw-media-index', String(self.gallery.length));
        openBtn.setAttribute('aria-label', self.t(isVideo ? 'lbOpenVideo' : 'lbOpen', {
          name: review.display_name || ''
        }));

        if (poster) {
          var img = document.createElement('img');
          img.src = poster;
          img.loading = 'lazy';
          img.alt = self.t(isVideo ? 'videoAlt' : 'mediaAlt');
          if (m.width) img.width = m.width;
          if (m.height) img.height = m.height;
          openBtn.appendChild(img);
        } else {
          openBtn.appendChild(el('span', 'native-reviews__media-blank'));
        }
        if (isVideo) {
          var badge = el('span', 'native-reviews__media-play');
          badge.appendChild(playIcon());
          openBtn.appendChild(badge);
        }

        // El orden de este push es el orden de la galería plana, porque
        // render() recorre las reseñas y sus archivos en el orden pintado.
        self.gallery.push({
          review: review,
          type: isVideo ? 'video' : 'image',
          url: m.url,
          poster: m.thumbnail_url || '',
          thumb: poster,
          width: m.width || 0,
          height: m.height || 0
        });
        mediaWrap.appendChild(openBtn);
      });
      if (mediaWrap.childNodes.length) main.appendChild(mediaWrap);
    }

    if (review.reply && review.reply.body) {
      var reply = el('div', 'native-reviews__reply');
      reply.appendChild(el('p', 'native-reviews__reply-label', this.t('replyLabel')));
      reply.appendChild(el('p', 'native-reviews__reply-body', review.reply.body));
      main.appendChild(reply);
    }

    // helpfulEnabled === false: votar está apagado y la fila NO se pinta — ni la
    // pregunta ni los botones. No se pinta deshabilitada: si la función no está,
    // no existe. Con null (form-config aún en vuelo) sí se construye, y el CSS la
    // mantiene oculta hasta que la respuesta ponga data-nrw-helpful en la raíz;
    // así no se enseña para quitarla dos décimas después.
    if (this.helpfulEnabled !== false) main.appendChild(this.helpfulRow(review));

    item.appendChild(main);
    return item;
  };

  /**
   * Permiso de votos. `data-nrw-helpful` en la raíz es lo que hace visible la
   * fila (ver el CSS de la sección): un solo atributo enciende o apaga los
   * pulgares de TODAS las reseñas pintadas a la vez, sin re-renderizar la lista.
   *
   * Aquí el valor es siempre booleano: `null` solo existe ANTES de la primera
   * respuesta de form-config (lo pone el constructor) y significa "aún no se
   * sabe". Un form-config que contesta sin `helpful_enabled` —un backend anterior
   * al endpoint de votos— es un NO, no una incógnita.
   */
  ReviewsWidget.prototype.applyHelpfulConfig = function (enabled) {
    this.helpfulEnabled = !!enabled;
    if (this.helpfulEnabled) this.root.setAttribute('data-nrw-helpful', '');
    else this.root.removeAttribute('data-nrw-helpful');
  };

  /**
   * POST /v1/reviews/{id}/helpful — el voto entero, en UNA petición.
   *
   * El cuerpo es ESTRICTO: solo `direction`; un campo de más responde 422. No
   * lleva `submission_id`, ni captcha, ni `grant`, ni cabeceras especiales. El
   * `{id}` va en el path, así que se escapa. Mismo régimen CORS que el resto de
   * la escritura (STOREFRONT_ORIGIN): mode cors + credentials omit.
   */
  ReviewsWidget.prototype.sendHelpfulVote = function (reviewId, direction) {
    return fetch(BASE_URL + '/v1/reviews/' + encodeURIComponent(reviewId) + '/helpful', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      mode: 'cors',
      credentials: 'omit',
      body: JSON.stringify({ direction: direction })
    }).then(readProblem);
  };

  /**
   * Errores del voto (RFC 9457). NINGUNO se reintenta solo, y el pintado ya se
   * revirtió antes de llegar aquí.
   *   403 -> alguien apagó el interruptor con la página abierta: la fila
   *          desaparece de TODA la lista, no solo de esta reseña.
   *   404 -> la reseña no existe o dejó de estar publicada: se oculta su fila.
   *   422 -> bug del cliente (`direction` mal); reintentar no lo arregla.
   *   429 -> 60 peticiones/hora por IP agotadas.
   * El resto (fallo de red, 5xx) cae en el mismo mensaje genérico. No hay 409,
   * ni 401, ni 503 en este endpoint.
   */
  ReviewsWidget.prototype.handleHelpfulError = function (err, row, msgEl) {
    var status = (err && err.problem && err.problem.status) || 0;
    if (status === 403) { this.applyHelpfulConfig(false); return; }
    if (status === 404) { row.setAttribute('hidden', ''); return; }
    if (msgEl) {
      msgEl.setAttribute('data-state', 'error');
      msgEl.textContent = this.t('helpfulError');
    }
    if (window.console && console.warn) console.warn('[native-reviews] helpful', err);
  };

  /**
   * Fila "¿Fue útil esta reseña?": la pregunta, los dos pulgares y un hueco
   * aria-live donde aterriza el resultado.
   *
   * La semántica es de INTERRUPTOR, no de "me gusta" que solo sube:
   *   sin voto + up   -> up         helpful +1
   *   up       + up   -> SIN VOTO   helpful -1   (el segundo clic apaga el primero)
   *   up       + down -> down       helpful -1, not_helpful +1  (cambia de lado)
   * Una persona aporta como mucho un voto, y a un solo lado. Por eso los botones
   * llevan aria-pressed: es literalmente para lo que existe.
   *
   * Pintado OPTIMISTA con rollback: el cambio se aplica al instante y, si la
   * respuesta no es 200, se revierte. Con 200 los conteos de la respuesta
   * SUSTITUYEN a los predichos — son la verdad y pueden no coincidir, otra
   * persona pudo votar entre medias. La lista NO se vuelve a pedir: la respuesta
   * ya trae los conteos, y recargar tiraría el scroll y la página actual.
   *
   * El estado pintado se reconstruye aquí, en cada renderItem, y no se queda en
   * el DOM: la lista se rehace entera al paginar, al reordenar y en el swap de
   * color.
   *
   * El `CustomEvent('hs:reviews-vote')` que emitía el clic mientras esto era
   * decorativo SE QUITA: no lo escuchaba nadie (ni en el tema ni en los scripts
   * de las apps), así que mantenerlo solo dejaba una API pública falsa.
   */
  ReviewsWidget.prototype.helpfulRow = function (review) {
    var self = this;
    var reviewId = review.id;
    var row = el('div', 'native-reviews__item-helpful');
    row.appendChild(el('span', 'native-reviews__helpful-q', this.t('helpfulQuestion')));

    // Conteos reales de la lista; el voto propio sale de localStorage (decora).
    var counts = {
      up: Math.max(0, parseInt(review.helpful_count, 10) || 0),
      down: Math.max(0, parseInt(review.not_helpful_count, 10) || 0)
    };
    var vote = readVote(reviewId);
    var busy = false;
    var btns = {};
    var counters = {};

    ['up', 'down'].forEach(function (dir) {
      var btn = el('button', 'native-reviews__helpful-btn');
      btn.type = 'button';
      btn.setAttribute('data-vote', dir);
      btn.appendChild(thumb(dir));
      counters[dir] = el('span', 'native-reviews__helpful-count', '0');
      btn.appendChild(counters[dir]);
      btn.addEventListener('click', function () { send(dir); });
      btns[dir] = btn;
      row.appendChild(btn);
    });

    // Mismo patrón que el contador del lightbox: role=status + aria-live. Nace
    // fuera de pantalla (solo lo oye el lector) y solo se hace visible cuando
    // lleva un error, que sí hay que enseñar.
    var msgEl = el('span', 'native-reviews__helpful-msg');
    msgEl.setAttribute('role', 'status');
    msgEl.setAttribute('aria-live', 'polite');
    row.appendChild(msgEl);

    // aria-label describe la ACCIÓN, no el icono, y cambia a su variante "ya
    // votado" para que el lector no oiga solo un número.
    function labelKey(dir, voted) {
      if (dir === 'up') return voted ? 'helpfulUpVoted' : 'helpfulUp';
      return voted ? 'helpfulDownVoted' : 'helpfulDown';
    }

    function paint() {
      ['up', 'down'].forEach(function (dir) {
        var voted = vote === dir;
        counters[dir].textContent = String(counts[dir]);
        btns[dir].setAttribute('aria-pressed', voted ? 'true' : 'false');
        btns[dir].setAttribute('aria-label', self.t(labelKey(dir, voted), { count: counts[dir] }));
        btns[dir].disabled = busy;
      });
    }

    // La tabla del toggle, tal cual. El clamp a 0 está porque el conteo local
    // puede partir de un localStorage que el servidor ya no reconoce (se votó
    // desde otro dispositivo, o la identidad aproximada cambió): pintar -1 sería
    // peor que quedarse en 0, y el 200 lo corrige acto seguido.
    function applyToggle(dir) {
      if (vote === dir) {
        counts[dir] = Math.max(0, counts[dir] - 1);
        vote = '';
        return;
      }
      if (vote) counts[vote] = Math.max(0, counts[vote] - 1);
      counts[dir] += 1;
      vote = dir;
    }

    function send(dir) {
      // Bloqueo del doble envío MIENTRAS la petición está en vuelo. Lo que no se
      // hace es bloquear el segundo clic porque localStorage diga que ya votó: la
      // petición se manda igual y el backend la lee como retiro o como cambio de
      // sentido, que es justo lo que el usuario quiere.
      if (busy || !BASE_URL || !reviewId) return;
      var prev = { up: counts.up, down: counts.down, vote: vote };
      applyToggle(dir);
      busy = true;
      msgEl.removeAttribute('data-state');
      msgEl.textContent = '';
      paint();

      self.sendHelpfulVote(reviewId, dir)
        .then(function (body) {
          busy = false;
          body = body || {};
          // Cada campo se sustituye SOLO si de verdad vino. El contrato los manda
          // siempre, pero un 2xx con el cuerpo vacío (un 204, un proxy raro)
          // dejaría los conteos a 0 y borraría el voto recién puesto; quedarse
          // con lo optimista es, en ese caso, lo más parecido a la verdad.
          if (body.helpful_count !== undefined) counts.up = Math.max(0, parseInt(body.helpful_count, 10) || 0);
          if (body.not_helpful_count !== undefined) counts.down = Math.max(0, parseInt(body.not_helpful_count, 10) || 0);
          if (body.your_vote !== undefined) {
            // `null` sí es significativo: acaba de RETIRAR el voto.
            vote = body.your_vote === 'up' || body.your_vote === 'down' ? body.your_vote : '';
          }
          saveVote(reviewId, vote);
          // Abre la ventana de revalidación: a partir de aquí la próxima carga
          // de la lista no puede salir del caché rancio.
          markVoted();
          paint();
          // Se anuncia con la etiqueta del pulgar pulsado: ya lleva el conteo
          // nuevo y si el voto quedó puesto o retirado.
          msgEl.textContent = self.t(labelKey(dir, vote === dir), { count: counts[dir] });
        })
        .catch(function (err) {
          busy = false;
          counts.up = prev.up;
          counts.down = prev.down;
          vote = prev.vote;
          paint();
          self.handleHelpfulError(err, row, msgEl);
        });
    }

    paint();
    return row;
  };

  ReviewsWidget.prototype.renderPagination = function (pagination) {
    this.pagerEl.innerHTML = '';
    var totalPages = pagination.total_pages || 1;
    if (totalPages <= 1) return;

    var current = pagination.page || this.page;
    var self = this;

    function goTo(page) {
      if (page < 1 || page > totalPages || page === self.page) return;
      self.page = page;
      self.fetch();
      self.scrollIntoView();
    }

    var prev = el('button', 'native-reviews__page-btn');
    prev.type = 'button';
    prev.setAttribute('aria-label', this.t('prev'));
    prev.appendChild(chevron('prev'));
    if (current <= 1) prev.disabled = true;
    prev.addEventListener('click', function () { goTo(current - 1); });
    this.pagerEl.appendChild(prev);

    paginationRange(current, totalPages).forEach(function (page) {
      if (page === '…') {
        self.pagerEl.appendChild(el('span', 'native-reviews__page-ellipsis', '…'));
        return;
      }
      var btn = el('button', 'native-reviews__page-num', String(page));
      btn.type = 'button';
      if (page === current) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'page');
      }
      btn.addEventListener('click', function () { goTo(page); });
      self.pagerEl.appendChild(btn);
    });

    var next = el('button', 'native-reviews__page-btn');
    next.type = 'button';
    next.setAttribute('aria-label', this.t('next'));
    next.appendChild(chevron('next'));
    if (current >= totalPages) next.disabled = true;
    next.addEventListener('click', function () { goTo(current + 1); });
    this.pagerEl.appendChild(next);
  };

  /**
   * Lightbox de fotos.
   *
   * La apertura va DELEGADA en la lista: los botones de foto se recrean en cada
   * render y un listener fijo en el <ol> sobrevive a todos, sin re-bindear nada.
   *
   * Cierre por overlay, boton X o Escape; navegacion con las flechas en pantalla
   * y con las del teclado. El foco queda atrapado en el dialogo mientras esta
   * abierto y vuelve a la miniatura que lo abrio al cerrar.
   */
  ReviewsWidget.prototype.bindLightbox = function () {
    var self = this;
    var modal = this.root.querySelector('[data-nrw-lightbox]');
    if (!modal) return;
    this.lbModal = modal;
    this.lbDialog = modal.querySelector('.native-reviews-lb__dialog');
    this.lbImage = modal.querySelector('[data-nrw-lb-image]');
    this.lbVideo = modal.querySelector('[data-nrw-lb-video]');
    this.lbPrev = modal.querySelector('[data-nrw-lb-prev]');
    this.lbNext = modal.querySelector('[data-nrw-lb-next]');
    this.lbName = modal.querySelector('[data-nrw-lb-name]');
    this.lbDate = modal.querySelector('[data-nrw-lb-date]');
    this.lbVerified = modal.querySelector('[data-nrw-lb-verified]');
    this.lbStars = modal.querySelector('[data-nrw-lb-stars]');
    this.lbTitle = modal.querySelector('[data-nrw-lb-title]');
    this.lbThumbs = modal.querySelector('[data-nrw-lb-thumbs]');
    this.lbBody = modal.querySelector('[data-nrw-lb-body]');
    this.lbCounter = modal.querySelector('[data-nrw-lb-counter]');
    this.lbThumbBtns = [];

    if (this.listEl) {
      this.listEl.addEventListener('click', function (ev) {
        var target = ev.target;
        if (!target || !target.closest) return;
        var btn = target.closest('[data-nrw-media-index]');
        if (!btn || !self.listEl.contains(btn)) return;
        ev.preventDefault();
        self.openLightbox(parseInt(btn.getAttribute('data-nrw-media-index'), 10), btn);
      });
    }

    Array.prototype.forEach.call(
      modal.querySelectorAll('[data-nrw-lb-close]'),
      function (node) {
        node.addEventListener('click', function () { self.closeLightbox(); });
      }
    );
    if (this.lbPrev) {
      this.lbPrev.addEventListener('click', function () { self.showSlide(self.lbIndex - 1); });
    }
    if (this.lbNext) {
      this.lbNext.addEventListener('click', function () { self.showSlide(self.lbIndex + 1); });
    }

    this.onLightboxKeydown = function (ev) {
      if (modal.hasAttribute('hidden')) return;
      if (ev.key === 'Escape') { self.closeLightbox(); return; }
      if (ev.key === 'ArrowLeft') { ev.preventDefault(); self.showSlide(self.lbIndex - 1); return; }
      if (ev.key === 'ArrowRight') { ev.preventDefault(); self.showSlide(self.lbIndex + 1); return; }
      if (ev.key === 'Tab') self.trapFocus(ev, self.lbDialog);
    };
    document.addEventListener('keydown', this.onLightboxKeydown);
  };

  ReviewsWidget.prototype.openLightbox = function (index, trigger) {
    if (!this.lbModal || !this.gallery.length) return;
    if (isNaN(index) || index < 0 || index >= this.gallery.length) return;
    this.lbTrigger = trigger || null;
    this.lbModal.removeAttribute('hidden');
    this.lockScroll();
    // lbIndex en -1 fuerza a showSlide a pintar tambien la columna derecha.
    this.lbIndex = -1;
    this.showSlide(index);
    if (this.lbDialog) {
      this.lbDialog.scrollTop = 0;
      // Foco al dialogo (tabindex="-1"): el lector de pantalla anuncia el modal
      // antes que el primer control.
      this.lbDialog.focus();
    }
  };

  /**
   * Para el video del modal y lo descarga. `pause()` solo no basta: sin quitar el
   * src el navegador sigue con el archivo en memoria y en algunos móviles sigue
   * bajando datos. `load()` después de vaciarlo es lo que corta la descarga.
   */
  ReviewsWidget.prototype.stopLightboxVideo = function () {
    if (!this.lbVideo) return;
    try {
      this.lbVideo.pause();
      this.lbVideo.removeAttribute('src');
      this.lbVideo.load();
    } catch (e) { /* noop */ }
  };

  ReviewsWidget.prototype.closeLightbox = function () {
    if (!this.lbModal || this.lbModal.hasAttribute('hidden')) return;
    this.lbModal.setAttribute('hidden', '');
    this.lbIndex = -1;
    // Soltar el src: sin esto la foto a tamano completo sigue ocupando memoria
    // con el modal cerrado, y en movil eso se nota.
    if (this.lbImage) this.lbImage.removeAttribute('src');
    this.stopLightboxVideo();
    this.unlockScroll();
    if (this.lbTrigger && typeof this.lbTrigger.focus === 'function') this.lbTrigger.focus();
    this.lbTrigger = null;
  };

  /**
   * Muestra la foto `index` de la galeria plana. El indice es circular: pasada
   * la ultima se vuelve a la primera.
   *
   * La columna derecha solo se repinta cuando la foto nueva pertenece a OTRA
   * resena; moverse entre fotos de la misma resena no debe recrear las
   * miniaturas (se recargarian y parpadearian), solo mover el borde activo.
   */
  ReviewsWidget.prototype.showSlide = function (index) {
    var total = this.gallery.length;
    if (!total) return;
    var next = ((index % total) + total) % total;
    var entry = this.gallery[next];
    if (!entry) return;

    var prevEntry = this.lbIndex >= 0 ? this.gallery[this.lbIndex] : null;
    var changedReview = !prevEntry || prevEntry.review !== entry.review;
    this.lbIndex = next;

    // Cambiar de diapositiva siempre para y descarga el video anterior: sin esto
    // el audio sigue sonando sobre la foto siguiente y el archivo se queda en
    // memoria.
    this.stopLightboxVideo();

    var isVideo = entry.type === 'video';
    if (this.lbImage) {
      this.lbImage.hidden = isVideo;
      if (!isVideo) {
        // width/height antes del src: le dan al navegador la proporción real
        // mientras la foto carga, para que el hueco no salte dentro del stage.
        if (entry.width && entry.height) {
          this.lbImage.setAttribute('width', entry.width);
          this.lbImage.setAttribute('height', entry.height);
        } else {
          this.lbImage.removeAttribute('width');
          this.lbImage.removeAttribute('height');
        }
        this.lbImage.src = entry.url;
        this.lbImage.alt = this.t('mediaAlt');
      } else {
        this.lbImage.removeAttribute('src');
      }
    }
    if (this.lbVideo) {
      this.lbVideo.hidden = !isVideo;
      if (isVideo) {
        if (entry.poster) this.lbVideo.setAttribute('poster', entry.poster);
        else this.lbVideo.removeAttribute('poster');
        this.lbVideo.src = entry.url;
        // No arranca solo: un video con sonido reproduciéndose sin que nadie lo
        // pidiera es de las cosas que hacen cerrar una pestaña.
      }
    }
    // Con una sola foto en toda la pagina no hay a donde navegar.
    var single = total < 2;
    if (this.lbPrev) this.lbPrev.hidden = single;
    if (this.lbNext) this.lbNext.hidden = single;
    if (this.lbCounter) {
      this.lbCounter.textContent = this.t('lbCounter', { index: next + 1, total: total });
    }

    if (changedReview) this.renderLightboxDetail(entry.review);
    this.paintLightboxThumbs();
  };

  /** Columna derecha: autor, fecha, verificada, estrellas, titulo, miniaturas y cuerpo. */
  ReviewsWidget.prototype.renderLightboxDetail = function (review) {
    var self = this;
    if (this.lbName) this.lbName.textContent = review.display_name || '';
    if (this.lbDate) this.lbDate.textContent = fmtDate(review.created_at, this.locale);
    if (this.lbVerified) this.lbVerified.hidden = !review.verified_buyer;

    if (this.lbStars) {
      this.lbStars.innerHTML = '';
      var rating = Math.max(0, Math.min(5, Math.round(Number(review.rating) || 0)));
      for (var i = 1; i <= 5; i++) this.lbStars.appendChild(svgStar(i <= rating));
      this.lbStars.setAttribute('aria-label', this.t('ratingAria', { rating: rating }));
    }

    if (this.lbTitle) {
      this.lbTitle.textContent = review.title || '';
      this.lbTitle.hidden = !review.title;
    }
    if (this.lbBody) this.lbBody.textContent = review.body || '';

    // Miniaturas: las fotos de ESTA resena, pero cada una apuntando a su indice
    // en la galeria plana, para que el clic y las flechas hablen el mismo idioma.
    this.lbThumbBtns = [];
    if (!this.lbThumbs) return;
    this.lbThumbs.innerHTML = '';
    var own = [];
    this.gallery.forEach(function (item, i) {
      if (item.review === review) own.push({ item: item, index: i });
    });
    own.forEach(function (slot, n) {
      var btn = el('button', 'native-reviews-lb__thumb');
      btn.type = 'button';
      btn.setAttribute('aria-label', self.t('lbThumb', { index: n + 1, total: own.length }));
      if (slot.item.thumb) {
        var img = document.createElement('img');
        img.src = slot.item.thumb;
        // alt vacio a proposito: el aria-label del boton ya dice que hace; un alt
        // repetido haria que el lector lo anunciara dos veces.
        img.alt = '';
        btn.appendChild(img);
      } else {
        btn.appendChild(el('span', 'native-reviews-lb__thumb-blank'));
      }
      if (slot.item.type === 'video') {
        btn.className += ' native-reviews-lb__thumb--video';
        var thumbBadge = el('span', 'native-reviews-lb__thumb-play');
        thumbBadge.appendChild(playIcon());
        btn.appendChild(thumbBadge);
      }
      btn.addEventListener('click', function () { self.showSlide(slot.index); });
      btn.__nrwIndex = slot.index;
      self.lbThumbs.appendChild(btn);
      self.lbThumbBtns.push(btn);
    });
    // Una sola foto: la miniatura no aporta nada que no este ya en grande.
    this.lbThumbs.hidden = own.length < 2;
  };

  /** Mueve el borde negro a la miniatura de la foto que se esta viendo. */
  ReviewsWidget.prototype.paintLightboxThumbs = function () {
    var current = this.lbIndex;
    (this.lbThumbBtns || []).forEach(function (btn) {
      var on = btn.__nrwIndex === current;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-current', on ? 'true' : 'false');
    });
  };

  /**
   * Hace pulsables las estrellas que van junto al precio: llevan a la lista.
   *
   * La interactividad se agrega desde AQUI, no en reviews-stars.liquid, y eso es
   * deliberado. El bloque de estrellas se puede agregar SIN la seccion del
   * widget; en ese caso no hay lista a la que bajar y un control que no lleva a
   * ningun lado es peor que un dato inerte. Este metodo solo corre si hay un
   * widget en la pagina, asi que las estrellas se vuelven pulsables exactamente
   * cuando hay algo al otro lado.
   *
   * Viven FUERA del root (en la columna del precio), de ahi la busqueda a nivel
   * documento.
   */
  ReviewsWidget.prototype.bindNativeStars = function () {
    var self = this;
    var nodes = document.querySelectorAll('[data-native-reviews-stars]');
    Array.prototype.forEach.call(nodes, function (node) {
      // Un solo cableado por nodo: el constructor y el swap de color llaman a
      // esto, y en el swap solo el nodo re-renderizado llega limpio.
      if (node.__nrwStarsBound) return;
      node.__nrwStarsBound = true;

      node.setAttribute('role', 'button');
      node.setAttribute('tabindex', '0');
      node.classList.add('is-clickable');

      // El aria-label server-side dice la calificacion pero no que el control
      // hace algo; se le anade la accion sin perder la cifra.
      var label = node.getAttribute('aria-label') || '';
      var action = self.t('goToReviews');
      if (action) node.setAttribute('aria-label', label ? label + ' — ' + action : action);

      node.addEventListener('click', function () { self.scrollIntoView(); });
      // role="button" no trae el teclado de regalo: con un div hay que atender
      // Enter y Espacio a mano.
      node.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') {
          ev.preventDefault();
          self.scrollIntoView();
        }
      });
    });
  };

  ReviewsWidget.prototype.scrollIntoView = function () {
    try {
      this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) { /* noop */ }
  };

  /**
   * Desmonta la instancia. El editor de temas re-renderiza la sección en cada
   * cambio de ajuste: sin esto quedarían listeners colgados de `document`,
   * temporizadores vivos y un widget de Turnstile apuntando a un nodo muerto.
   */
  ReviewsWidget.prototype.destroy = function () {
    this.destroyed = true;
    if (this.onFormKeydown) document.removeEventListener('keydown', this.onFormKeydown);
    if (this.onLightboxKeydown) document.removeEventListener('keydown', this.onLightboxKeydown);
    if (this.onProductSwapped) document.removeEventListener('hs:product-swapped', this.onProductSwapped);
    if (this.io) {
      try { this.io.disconnect(); } catch (e) { /* noop */ }
    }
    window.clearTimeout(this.formConfigRetry);
    window.clearTimeout(this.holdTimer);
    if (window.turnstile && this.turnstileWidgetId !== null) {
      try { window.turnstile.remove(this.turnstileWidgetId); } catch (e) { /* noop */ }
    }
    this.turnstileWidgetId = null;
    this.turnstileState = 'idle';
    this.turnstileToken = '';
    // Si la sección se recarga con un modal abierto, el scroll debe volver.
    this.unlockScroll(true);
    this.root.__nativeReviews = null;
  };

  function initIn(container) {
    if (!container || !container.querySelectorAll) return;
    var roots = container.querySelectorAll('[data-native-reviews-widget]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__nativeReviews) return;
      root.__nativeReviews = new ReviewsWidget(root);
    });
  }

  function destroyIn(container) {
    if (!container || !container.querySelectorAll) return;
    var roots = container.querySelectorAll('[data-native-reviews-widget]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__nativeReviews) root.__nativeReviews.destroy();
    });
  }

  function init() { initIn(document); }

  // Editor de temas: la sección se destruye y se vuelve a montar en cada cambio.
  document.addEventListener('shopify:section:unload', function (ev) { destroyIn(ev.target); });
  document.addEventListener('shopify:section:load', function (ev) { initIn(ev.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
